/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiResponse {
  /**
   * 응답 코드 (0=성공, 그 외=오류)
   * @default 0
   */
  code: number;
  /** 응답 데이터 */
  data: Record<string, any>;
  /** 응답 메시지. 응답 코드가 0이 아닌 경우 오류 메시지. */
  message: string;
}

export interface TreatmentTag {
  /** 태그 고유 ID */
  tagId: string;
  /** 태그 이름 */
  name: string;
  /** 태그 색상 (Hex 코드) */
  color?: string;
  /** 자동화 알고리즘 적용 여부 */
  automationApplied?: boolean;
  /** 폴더 ID */
  folderID?: string;
  appliedAt?: string;
  /** 세종병원 연동 전용 진단 코드 */
  mappedDiagnosisCode?: string;
  /** 세종병원 연동 전용 치료 태그 수정 여부 */
  isEditable?: boolean;
}

export interface HServiceMemoWriterModifier {
  /** 유저 ID */
  userID?: string;
  /** 서비스 ID */
  hserviceID?: string;
  /** 병원 ID */
  hospitalID?: string;
  /** 메모 내용 */
  content?: string;
  /** 작성자 ID */
  writerID?: UserNameAndType;
  /** 작성자 타입 */
  writerType?: number;
  /** 수정자 ID */
  modifierID?: UserNameAndType;
  /** 수정자 타입 */
  modifierType?: number;
  /** 생성일시 */
  createdAt?: string;
  /** 수정일시 */
  updatedAt?: string;
}

export interface UserNameAndType {
  /** 유저 ID */
  _id: string;
  /** 이름 */
  name: string;
  /** 유저의 실제 이름 */
  realName: string;
  /** 유저 타입 */
  type: string;
  /** 유저의 직무 또는 직책 */
  jobType: string;
}

export interface OngoingAutomation {
  /** 알고리즘 ID */
  algorithmId: string;
  /** 알고리즘 이름 */
  algorithmName: string;
  /** 알고리즘이 적용된 국적 이름 목록 */
  appliedNationalityNames: string[];
  /** 폴더에 속하지 않은 태그 목록 */
  tagsHaveNoFolder: {
    /**
     * 치료 태그 ID
     * @example "5f9b3b4e1c9d440000000001"
     */
    tagId: string;
    /**
     * 치료 태그 이름
     * @example "보톡스 윤곽"
     */
    tagName: string;
    /**
     * 태그 색상
     * @example "#FF0000"
     */
    tagColor?: string;
  }[];
  /** 폴더에 속한 태그 목록 */
  tagsHaveFolder: {
    /**
     * 폴더 ID
     * @example "5f9b3b4e1c9d440000000001"
     */
    folderID: string;
    /**
     * 폴더 이름
     * @example "피부 관리 시술"
     */
    folderName: string;
    /** 폴더에 속한 태그 목록 */
    tags: {
      /**
       * 치료 태그 ID
       * @example "5f9b3b4e1c9d440000000001"
       */
      tagId: string;
      /**
       * 치료 태그 이름
       * @example "보톡스 윤곽"
       */
      tagName: string;
      /**
       * 태그 색상
       * @example "#FF0000"
       */
      tagColor?: string;
    }[];
  }[];
  /** 알고리즘이 적용된 태그 이름 목록 */
  appliedTagNames?: string[];
}

export interface HServiceTempPatient {
  /** 서비스 대상의 이름 */
  name: string;
  /** 서비스 대상의 전화번호 */
  phone: string;
  /** 서비스 대상의 생년월일 */
  birthdate?: string;
  /** 서비스 대상의 성별 */
  gender?: string;
  /** 서비스 대상의 차트번호 */
  chartNumber?: string;
  /** 서비스 대상의 국가 코드 */
  countryCode?: {
    /** 국가 코드 ID */
    id?: string;
    /** 한글 국가 이름 */
    koreanCountryName?: string;
    /** 국가 코드 리스트 */
    internationalDialingCodes?: string;
  };
  /** 초진/재진 여부 */
  isFirstVisit?: boolean;
  /** 메시지(광고성 SMS) 발송 차단 여부 */
  hasToBlockSendingMessage?: boolean;
}

export interface TemporaryPatientsDeletionHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 삭제 성공 여부
     * @example true
     */
    isDeletedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface UserHServicePhotoAuthorizationType {
  /** 사용자 아이디 - ObjectId */
  _id: string;
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: File;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: HServiceNurseDoctorHospitalChatroom[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
  /**
   * 기본 상담사 여부
   * @default false
   */
  isDefaultCounselor: boolean;
}

export interface File {
  /**
   * 파일 ID
   * @example "66aca461f8238a4fd30abe15"
   */
  _id: string;
  /** 파일의 소유자 ID */
  userID?: string;
  /**
   * 파일 타입
   * - 300: Image
   * - 400: Video
   * - 500: File
   */
  type: number;
  /** 파일 객체에 포함된 파일의 URL 배열 */
  paths: string[];
  /** 파일 별, S3 스토리지에 업로드 된 파일의 정보 객체 배열 */
  aws?: Record<string, any>[];
  /** 파일 만료일. 외부 연동 서비스일 경우에 존재 */
  expiredAt?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface HServiceNurseDoctorHospitalChatroom {
  /** 서비스 대상이 되는 유저 ID */
  userID?: string;
  /** 서비스 대상의 이름 */
  name?: string;
  /** 서비스 대상의 생년월일 */
  birth?: string;
  /** 서비스 대상의 전화번호 */
  phone?: string;
  /** 서비스 대상의 성별 */
  gender?: string;
  /** 서비스 대상의 차트번호 */
  chartNumber?: string;
  /** 서비스 진행 매니저의 ID */
  nurseID?: UserPhoto;
  /** 서비스 진행 매니저가 여럿인 경우의 매니저 ID 배열 */
  nurseIDs?: any[];
  /** 담당의 유저 ID */
  doctorID?: User;
  /** 서비스가 진행중인 병원의 ID */
  hospitalID?: HospitalRepresentImage;
  /** 서비스 내 포함된 채팅방 ID */
  chatRoomID?: ChatRoom;
  /** 전능 대표 연동 고객번호 (유일) */
  ALCustomerNumber?: string;
  /** 전능 연동 고객번호 리스트 */
  ALCustomerNumbers?: any[];
  /** 서비스 내 작성된 모든 메모의 ID 배열 */
  memos?: any[];
  /** 매니저만 작성/열람 가능한 메모 ID 배열 */
  managementDiaries?: any[];
  /** 고객 태그 ObjectID 배열 */
  userTagIDs?: any[];
  /** 환자 설정 완료 여부(설정/미설정 수 count용) */
  hasPatientSetting?: boolean;
  /** 초기 치료내역 문자열 배열 */
  initialTreatments?: any[];
  /** 초기 치료내역 중  기타를 선택하고 입력한 내역 */
  etcTreatments?: string;
  /** 읽지 않은 매니저 메모의 존재 여부 */
  hasUnreadNurseMemo?: boolean;
  /** 읽지않은 병원 메모 존재 유무 */
  hasUnreadDoctorMemo?: boolean;
  /** 문자유입 프로세스를 통해 서비스를 시작한 경우 유입 Link */
  shortLinkID?: string;
  /** 링크형태의 웹을 통해 진입한 유저의 경우 Type */
  linkType?: string;
  /** 서비스 환자에 대한 간단 설명 */
  description?: string;
  /** 병원 계정의 경우  new 뱃지 표기를 위한 플래그 */
  new?: boolean;
  /** 가입 상태에 대한 string 플래그 */
  status?: string;
  /** query를 위한 서비스 시작 여부 플래그 */
  isRun?: boolean;
  /** 서비스 종료 구분 플래그 */
  isClosed?: boolean;
  /** 서비스 종료시 사용자가 선택한 서비스 종료 이유. 혹은 병원에서 서비스를 종료한 후 사용자에게 보여주기 위한 문구. */
  closeReason?: any[];
  /** 서비스 약관 동의 일시 (HService 기준) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (HService 기준) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (HService 기준) */
  agree_sensitive?: string;
  /** 가입일시 */
  joinedAt?: string;
  /** 서비스 대상 유저의 마지막 로그인 일시 */
  lastLogin?: string;
  /** 마지막 유저의 채팅 모델 ID */
  lastUserChat?: string;
  /** 마지막 유저의 채팅 전송 일시 */
  lastUserChatDate?: string;
  /** 마지막 유저 채팅 존재 유무 */
  hasLastUserChat?: boolean;
  /** 마지막 매니저의 채팅 모델 ID */
  lastNurseChat?: string;
  /** 마지막 매니저의 채팅 전송 일시 */
  lastNurseChatDate?: string;
  /** 마지막 매니저 채팅 존재 유무 */
  hasLastNurseChat?: boolean;
  /** 채팅방에서 마지막으로 수신한 메세지 */
  lastMessage?: string;
  /** 마지막으로 수신된 메세지의 수신 일시 */
  lastMessageUpdatedAt?: string;
  /** 마지막 가입 문자 메시지 수신일자 */
  lastSMSDate?: string;
  /** 고객 유형(치료 유형) 카테고리 ID 목록 */
  treatmentCategories?: any[];
  /** 치료시작일 */
  treatmentStartDate?: string;
  /** 초진/재진 여부 */
  isFirstVisit?: boolean;
  /** 테스트 계정 여부. */
  isTest?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** // 미가입 - 발송 예정인 기본 운동콘텐츠 목록 */
  reservedVCHIDs?: any[];
  /** 전송된 운동콘텐츠의 중 카테고리 ObjectID 배열. 누적 */
  vccIDs?: any[];
  /** 가장 최근에 운동콘텐츠가 전송된 날짜 */
  lastVCUDate?: string;
  /** 모든 운동콘텐츠가 종료되는 날짜 */
  lastVCUEndDate?: string;
  /** 직접 전송한 운동콘텐츠 유무. */
  hasVCU?: boolean;
  /** 병원에서 설정한 평균 이행률 이상 달성했는지 여부 */
  isOverHCompletionRate?: boolean;
  /** 운동콘텐츠 진행중 여부. */
  isVCUOngoing?: boolean;
  /** 합산 공유횟수(현재 반올림 하여 정수로 표현중이나  변경될 수 있음.) */
  sumShareCount?: number;
  /** 평균 이행률(현재 반올림 하여 정수로 저장하나  double 로 변경될 수 있음) */
  avgCompletionRate?: number;
  /** 운동콘텐츠 전송 필요 종모양 알람 표시 여부 */
  needVCU?: boolean;
  /** 운동콘텐츠 발송화면(Electron) 에서의 정렬을 위한 코드 */
  sortDigitVC?: string;
  /** 구분정보1 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote1?: string;
  /** 구분정보2 서비스 매니저가 고객별 입력 가능한 구분정보 */
  classificationNote2?: string;
  /** 서비스 시작을 기준으로 카운팅되는 정수 인덱스 */
  seq?: number;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
  /** 서비스 시작일 */
  startedAt?: string;
}

export interface UserPhoto {
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: File;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: any[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
}

export interface AuthorizationType {
  /** 권한타입 객체 오브젝트 아이디 */
  _id: string;
  /**
   * 샘플 데이터 구분
   * @default false
   */
  isSample?: boolean;
  /** 권한타입이 속한 병원 아이디 */
  hospitalID: string;
  /** 권한타입의 이름. 마스터, 관리자, 일반 중 하나 */
  name?: string;
  /** 환자 채팅 관리 권한 */
  canControlPatientChatting?: boolean;
  /** 환자 서비스 차단 권한 */
  canBanPatientToService?: boolean;
  /** 자동화 설정 권한 */
  canUpsertAutomation?: boolean;
  /** 자동화 삭제 권한 */
  canDeleteAutomation?: boolean;
  /** 자동화 대시보드 조회 권한 */
  canReadAutomationDashboard?: boolean;
  /** 콘텐츠 수정 권한 */
  canUpsertContent?: boolean;
  /** 콘텐츠 삭제 권한 */
  canDeleteContent?: boolean;
  /** 메뉴얼 폴더 및 태그 설정 권한 */
  canControlManualFolderAndTagStatus?: boolean;
  /** 메뉴얼 생성 권한 */
  canCreateManual?: boolean;
  /** 병원 정보 조회 권한 */
  canAccessHospitalInformation?: boolean;
  /** 서비스 정보 조회 권한 */
  canAccessHospitalService?: boolean;
  /** 계정 정보 조회 권한 */
  canAccessHospitalAccount?: boolean;
  /** 결제 관리 접근 권한 */
  canAccessPaymentManagement?: boolean;
  /** 결제 권한 */
  canCreatePayment?: boolean;
  /** 서비스 정보 수정 권한 */
  canModifyService?: boolean;
  /** 서비스 종료 권한 */
  canSuspendService?: boolean;
  /** 예약설정 수정 권한 */
  canManageReservation?: boolean;
  /** 예약설정 스케줄 수정 권한 */
  canManageSchedule?: boolean;
  /** 병원정보 수정 권한 */
  canUpdateHospital?: boolean;
  /** 환자 정보 다운로드 권한 */
  canDownloadPatientData?: boolean;
  /** 재진 마케팅 등록/수정 */
  canUpsertMarketingAutomation?: boolean;
  /** 재진 마케팅 삭제 */
  canDeleteMarketingAutomation?: boolean;
  /** 대시보드 조회 여부 */
  canReadMarketingAutomationDashboard?: boolean;
  /** 결제 정보 조회 여부 */
  canReadPaymentRecords?: boolean;
  /** 재진마케팅 전송 기록 엑셀 다운로드 권한 */
  canDownloadMarketingHistory?: boolean;
  /** 상담자동화 발송 기록 엑셀 다운로드 권한 */
  canDownloadConsultationHistory?: boolean;
  /** 메디팔 AI 사용현황 조회 권한 */
  canReadMedipalAIUsage?: boolean;
  /** 메디팔 AI 업무 조정 권한 */
  canAdjustMedipalAITask?: boolean;
  /** 메디팔 AI 예약 조회 권한 */
  canReadMedipalAIReservation?: boolean;
  /** 메디팔 AI 콜 조회 권한 */
  canReadMedipalAICall?: boolean;
  /** 메디팔 AI 콜 최고 권한 */
  canControlMedipalAICall?: boolean;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface User {
  /** 전화번호 문자열 */
  phone?: string;
  /** 유저의 타입. */
  type?: number;
  /** 로그인 시 사용되는 id */
  id?: string;
  /** 실 이름 */
  realName?: string;
  /** 유저가 보는 이름 */
  name?: string;
  /** 생년 월 일 */
  birth?: string;
  /** 사용자의 성별. */
  gender?: string;
  /** 사용자의 나이 */
  age?: string;
  visit?: string;
  /** 사용자의 상태 */
  status?: string;
  /** 프로필 이미지로 사용될 파일의 ID */
  photo?: string;
  /** 마지막으로 저장된 fcm token 값 */
  fcmToken?: string;
  /** 등록된 모든 fcm token 배열 */
  deviceTokens?: any[];
  /** fcm token 값을 키로 한 디바이스 정보 */
  deviceInfos?: Record<string, any>;
  /** 마지막으로 저장된 사용자의 OS 정보 */
  d_OS?: string;
  /** 마지막으로 저장된 OS 버전 정보 */
  d_OS_Version?: string;
  /** 마지막으로 저장된 App 버전 정보 */
  d_App_Version?: string;
  /** 마지막으로 저장된 디바이스의 이름 */
  d_Name?: string;
  /** 사용자가 진행중인 HService ID 배열 */
  hservices?: any[];
  /** 사용자가 속해 있는 병원 ID 배열 */
  hospitalID?: any[];
  /** 계정의 초기화 진행 여부 플래그 */
  needInitial?: boolean;
  /** 매니저 유저의 경우  소개글 */
  introduction?: string;
  /** 매니저 계정의 경우  경력. */
  career?: string;
  isAfterDoc?: boolean;
  /** 계정의 탈퇴 여부 플래그 */
  isLeave?: boolean;
  /** 마지막으로 로그인한 일시 */
  lastLogin?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막으로 수정된 일시 */
  updatedAt?: string;
  /** 환자의 경우  가입 일시. (가장 최근 가입한 HService 기준 갱신) */
  joinedAt?: string;
  /** 의사 계정 여부 플래그. type 이 2000번대(병원 사용자)일때만 유효한 값. */
  isDoctor?: boolean;
  /** 예약만 등록 유저 여부 */
  isUnregisteredUser?: boolean;
  /** 환자의 경우  가입하게된 Short URL 경로 */
  joinPath?: string;
  /** 환자의 경우  가입 시 방문한 경유페이지(layover) */
  layoverType?: string;
  /** 서비스 약관 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_terms?: string;
  /** 개인정보 보호방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_privacy?: string;
  /** 민감정보 관리방침 동의 일시 (가장 최근 가입한 HService 기준 갱신) */
  agree_sensitive?: string;
  /** 병원 계정의 경우  환자 등록 가능 여부 플래그 */
  auth_regist_user?: boolean;
  /** 권한 설정 ID */
  authorizationTypeID?: AuthorizationType;
  /** 병원내 계정의 직/직책 */
  jobType?: string;
  /** 대시보드 접근권한 */
  canReadDashboard?: boolean;
}

export interface HospitalRepresentImage {
  /** 병원의 정식 명칭 */
  name?: string;
  /** 사용자에게 보여질 병원명 */
  shortName?: string;
  /** 병원 주소 */
  address?: string;
  /** 병원 주소체계 검색 및 지도용 주소 정보 */
  addressInfo?: Record<string, any>;
  /** 네이버 지도 API 사용을 위한 주소 정보 */
  addressInfoNaver?: Record<string, any>;
  /** 병원의 과 ID */
  department?: any[];
  /** 병원 소개 글 */
  introduction?: string;
  /** 병원 정보페이지에 노출 될 이미지 파일 ID */
  representImage?: File;
  /** 대표 원장님 */
  representUser?: string;
  /** 병원의 홈페이지 URL */
  homepageURL?: string;
  /** 병원 전화번호 */
  phone?: string;
  /** 병원 전화번호 숨김 여부 */
  isHiddenPhoneNumber?: boolean;
  /** 병원 홈페이지 / 전화번호 사용여부 */
  usingHomepage?: boolean;
  /** 초기 채팅 발송 문구 */
  initialChat?: any[];
  /** 초기 채팅 발송 문구 (텍스트 및 이미지) */
  initialChats?: any[];
  /** 환자 관리를 위해서 매니저가 사용할 ServiceFlagCategory의 디폴트 값 아이디 */
  defaultFlag?: string;
  /** 1차 프로덕트에서 사용된 치료 목록 */
  therapyList?: any[];
  /** 서비스 매니저측에서 병원에 대한 특이사항을 기록하기 위한 JSON Object. */
  additionalInfo?: Record<string, any>;
  /** 문자유입 프로세스 내에서 기본 메세지 발송 여부 플래그 */
  isBasicMessage?: boolean;
  /** 문자유입 시 발송될 기본 문구 */
  smsMessage?: string;
  /** AB 테스트를 위한 메세지 문구 A */
  smsMessageA?: string;
  /** AB 테스트를 위한 메세지 문구 B */
  smsMessageB?: string;
  /** 자동 발송될 기본 채팅 메세지 */
  smsChatMessage?: string;
  /** AB 테스트를 위한 초기 채팅 메세지 A */
  smsChatMessageA?: string;
  /** AB 테스트를 위한 초기 채팅 메세지 B */
  smsChatMessageB?: string;
  /** 고객등록시 가입 문자 직접입력 설정 여부 */
  usingBasicMessage?: boolean;
  /** 고객등록시 가입 문자 기본 문구 */
  smsBasicMessage?: string;
  /** 고객등록시 가입 문자 직접 입력 문구 */
  smsBasicMessageEdit?: string;
  /** 예약등록시 가입 문자 직접입력 설정 여부 */
  usingReservationMessage?: boolean;
  /** 예약등록시 가입 문자 기본 문구 */
  smsReservation?: string;
  /** 예약등록시 가입 문자 직접 입력 문구 */
  smsReservationEdit?: string;
  /** 기존 고객 가입 문자 재발송 직접입력 설정 여부 */
  usingResendMessage?: boolean;
  /** 기존 고객 가입 문자 재발송 기본 문구 */
  smsResendMessage?: string;
  /** 기존 고객 가입 문자 재발송 직접 입력 문구 */
  smsResendMessageEdit?: string;
  /** 채팅 예약 발송 시 커스텀 메시지 */
  chatReservationGuide?: string;
  /** 진료 시간 */
  careSchedule?: any[];
  /** 진료 시간 설명 */
  careScheduleDescription?: string;
  /** 문자 유입내 사용할 이미지 파일 ID */
  smsLogoImage?: string;
  /** 문자유입간 이미지의 사용 여부 */
  isUsingLogo?: boolean;
  /** 담당 서비스매니저의 UserID */
  nurseID?: string;
  /** 병원별 여러명의 서비스 매니저를 담기 위한 서비스매니저의 User ID 배열 */
  nurseIDs?: any[];
  /** 담당 서비스 매니저가 여럿인지, 단일이지 구분짓기 위한 플래그 */
  hospitalType?: string;
  /** 문자 유입 사용여부 플래그 */
  usingRegistUser?: boolean;
  /** 서비스 진행 여부 플래그 */
  isClosed?: boolean;
  /** 서비스 설정 모델 ObjectId */
  serviceSetting?: string;
  /** 현재 모바일에서 예약가능한 시트가 존재하는지 확인하기 위한 플래그 */
  hasActiveSheet?: boolean;
  /** 2차 프로덕트 사용여부. */
  isSecondEdition?: boolean;
  /** 홈케어 콘텐츠 모듈 사용 여부 */
  usingVideoContent?: boolean;
  /** 병원 이벤트 모듈 사용여부 */
  usingHospitalEvent?: boolean;
  /** 모바일 홈화면에 표시될 건강 관리 뉴스 카테고리. */
  healthContentCategory?: any[];
  /** 건강콘텐츠 사용 여부 */
  usingHealthContent?: boolean;
  /** 병원 소식 사용 여부 */
  usingHospitalContent?: boolean;
  /** 연동 설정 모델 ObjectId */
  integrationSetting?: string;
  /** 애프터닥 운영시간 종료 후 환자 채팅 시, 팝업 표시 여부 */
  usingAfterhoursPopup?: boolean;
  /** 애프터닥 운영시간 종료 후 환자 채팅 시, 표시할 팝업 내용 */
  afterhoursPopupContent?: string;
  /** 자동 가입문자 재발송 사용 여부 */
  usingAutoReservedSMS?: boolean;
  /** 자동 재가입 문자 발송에 사용될 콘텐츠 */
  autoReservedSMSMessage?: string;
  /** 자동 재가입 문자 발송까지 대기할 날 */
  autoReservedSMSDelayDay?: number;
  /** 자동 재가입 문자가 발송될 시간 */
  autoReservedSMSHour?: number;
  /** 예약 시트 2차 버전 사용 여부 */
  usingV2ReservationSheet?: boolean;
  /** SaaS 예약시트 사용 여부 */
  usingSaaSReservation?: boolean;
  /** SaaS 프로덕트 사용 여부 */
  isEnabledSaaS?: boolean;
  /** 병원 별 언어와 국가 설정. 예: ko-KR (한국어, 대한민국), en-US (영어, 미국), vn-VN (베트남어, 베트남) */
  locale?: string;
  /** 병원 별 시간대 설정. 예: Asia/Seoul (서울), Asia/Ho_Chi_Minh (호치민) */
  timezone?: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface ChatRoom {
  /** 채팅방에 참여중인 서비스 ID */
  hserviceID?: string;
  /** 채팅방에 참여중인(Push notification을 받아야 하는.) 유저의 ID 배열 */
  users?: any[];
  /** 채팅의 주 대상이 되는(환자 or 의사) 유저의 ID */
  userID?: string;
  /** 채팅방 ID(_ID와 동일하고 _ID 사용 권장) */
  id?: string;
  /** 채팅방 _ID */
  _id: string;
  /** 채팅방 제목 */
  title?: string;
  /** 서비스매니저가 읽지 않은 채팅의 수 */
  n_UnreadCount?: number;
  /** 대상 유저가 읽지 않은 채팅의 수 */
  c_UnreadCount?: number;
  /** 채팅의 대상이 되는 유저가 처음 진입했는가에 대한 질의를 위한 플래그 */
  c_isFirstEnter?: boolean;
  /** 서비스 매니저의 첫 메세지 전송 여부 플래그 */
  c_isFirstNurseChat?: boolean;
  /** 대상 유저의 첫 메세지 구분 플래그 */
  c_isFirstUserChat?: boolean;
  /** 매니저의 첫 메세지 전송 이후를 확인하기 위한 플래그 */
  c_isSendedFirstNurseChat?: boolean;
  /** 해당 채팅방의 귀속 병원 ID */
  hospitalID?: string;
  /** 병원 계정과의 채팅방임을 구분짓는 플래그 */
  isDoctor?: boolean;
  /** 첫 메세지 전송을 통한 SMS 전송 여부 구분 플래그 */
  hasFirstSMS?: boolean;
  /** 마지막으로 전달된 메세지 모델 ID */
  lastMessage?: string;
  /** 마지막 메세지 전달 일시 */
  lastMessageUpdatedAt?: string;
  /** 채팅방 내에서의 총 메세지 수 */
  totalChatCount?: number;
  /** 마지막으로 환자가 전달한 채팅의 ObjectId */
  lastUserChat?: string;
  /** 마지막으로 환자가 전달한 채팅의 일시 */
  lastUserChatDate?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 ObjectId */
  lastNurseChat?: string;
  /** 마지막으로 환자가 아닌 유저가 전달한 채팅의 일시 */
  lastNurseChatDate?: string;
  /** 참여 유저별 뱃지 카운트 정보 */
  badgeCountInfo?: Record<string, any>;
  /** 사용자 ID 별 필요한 정보의 집합 */
  info: {
    /**
     * 사용자 ID
     * @example "60b12345b1234c56789abcd1"
     */
    userID: string;
    /**
     * 채팅을 읽지 않은 갯수
     * @example 0
     */
    count: number;
    /**
     * 개인별 출력되는 채팅방 제목
     * @example "단체방"
     */
    title: string;
  }[];
  /** 1대1 채팅방 구분자 */
  isMultiUser?: boolean;
  /** 채팅방의 병원 응대 필요 (상담 요청) 여부 */
  isChatResponseRequired?: boolean;
  /** 병원 응대 필요 채팅 (상담 요청) 존재 여부 */
  hasUnreadChatResponseRequired?: boolean;
  /** 채팅방 삭제 여부 */
  isRemoved?: boolean;
  /** 채팅방 타입 정의 */
  roomType?: string;
  /** 카카오 상담톡을 위한 추가 정보 */
  ikakaoInfo?: Record<string, any>;
  /** 채팅방의 담당자 ID 배열 */
  counselors?: any[];
  /**
   * 상담 진행중 여부
   * @default false
   */
  isCounselInProgress?: boolean;
  /**
   * 번역 사용 여부
   * @default false
   */
  usingTranslation?: boolean;
  /** 언어 ObjectId */
  languageID?: string;
  /** 활성화 여부 */
  isActive?: boolean;
  /** 채팅방에 연결된 부모 서비스 ID. 연동된 내용이 없으면 hserviceID와 동일 */
  parentHServiceID: string;
  /** 생성일 */
  createdAt?: string;
  /** 마지막 수정일 */
  updatedAt?: string;
}

export interface PatientControllerUpdateMarketingAgreementBodyRequest {
  patientID: string;
  enabled: boolean;
}

export interface PatientControllerUpdateMarketingAgreementResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: Record<string, any>;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PatientControllerCreateSinglePatientBodyRequest {
  countryCode: string;
  nationality?: string;
  phone: string;
  name: string;
  treatmentCategories: string[];
  customTagIDs?: string[];
  /** 광고성 메시지 수신 거부 여부 */
  hasToBlockSendingMessage?: boolean;
}

export interface PatientControllerCreateSinglePatientResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: Record<string, any>;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface SinglePatientDeletionHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 삭제 성공 여부
     * @example true
     */
    isDeletedSuccess: boolean;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PatientControllerCreateTemporaryPatientsBodyRequest {
  /** 임시 환자 목록 */
  patients: {
    /** 병원 ID */
    hospitalID: string;
    /** 임시 환자 ID */
    patientId?: string | null;
    /**
     * 환자 정보 임시 저장을 위한 순서값
     * @min 1
     */
    order: number;
    /** 고객 이름 */
    name?: string | null;
    /** 전화번호 */
    phoneNumber?: string | null;
    /** 국가 ID */
    countryCodeId?: string | null;
    /** 생년월일 */
    birthdate?: string | null;
    /** 성별 */
    gender?: "MALE" | "FEMALE" | null;
    /** 치료 태그 ID 목록 */
    treatmentTagIds?: string[];
    /** 초진 여부 */
    isFirstVisit?: boolean | null;
    /** 차트 번호 */
    chartNumber?: string | null;
    /** 국적 ID */
    nationalityId?: string | null;
    /** 메시지 수신 거부 여부 */
    hasToBlockSendingMessage?: boolean | null;
    /** 고객 태그 ID 목록 */
    customTagIDs?: string[];
    /** 과거 데이터 일괄 입력 여부 */
    isBulkImport?: boolean | null;
    /** 일괄 입력 건에 상담 자동화를 적용할지 여부 (기본 false) */
    applyConsultationAutomation?: boolean | null;
    /** 일괄 입력 건에 치료 주의사항을 발송할지 여부 (기본 false) */
    sendTreatmentCaution?: boolean | null;
    /** 고객 등록 실패 여부 */
    isFailed?: boolean | null;
    /** 일괄 입력 참조 키 (멱등성용, 워커가 job 단위 고정 키 전달) */
    bulkImportRefKey?: string;
    /** Vegas ERM ID */
    tnhErmCustomerId?: string | null;
    /** Vegas 고객 정보 */
    tnhCustomerInfo?: {
      name?: string | null;
      phone?: string | null;
      birth?: string | null;
      chartNumber?: string | null;
      gender?: string | null;
    };
  }[];
  /** 삭제할 임시 환자 ID 목록 */
  deletedPatientIds?: string[];
}

export interface PatientControllerCreateTemporaryPatientsResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 성공적으로 저장된 고객 수 */
    successCount: number;
    /** 저장 실패한 고객 수 */
    failCount: number;
    /** 실패 정보 목록 */
    failedInfos?: {
      /** 저장 실패한 환자 정보 */
      patient?: any;
      /** 에러 정보 */
      errors?: Record<string, any>;
    }[];
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PatientControllerGetTemporaryPatientMaxOrderResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 현재 임시 환자의 최대 order 값 (없으면 0) */
    maxOrder: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PatientControllerStartBulkRegistrationBodyRequest {
  /** 병원 ID */
  hospitalID: string;
  /** 과거 고객 업로드 일괄 입력 여부. true 인 경우 임시 환자 데이터 중 isBulkImport 가 true 인 데이터만 처리합니다. 기본값은 false 입니다. */
  isBulkImport?: boolean;
}

export interface PatientControllerStartBulkRegistrationResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 저장할 임시 환자 정보 전체 개수 */
    totalTargetCount: number;
    /** 일괄 처리 작업 ID — 해당 아이디로 일괄 처리 작업 상태를 조회할 수 있음 */
    bulkJobId: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PatientControllerStartBulkRegistrationLegacyBodyRequest {
  /** 병원 ID */
  hospitalID: string;
  /** 과거 고객 업로드 일괄 입력 여부. true 인 경우 임시 환자 데이터 중 isBulkImport 가 true 인 데이터만 처리합니다. 기본값은 false 입니다. */
  isBulkImport?: boolean;
}

export interface PatientControllerStartBulkRegistrationLegacyResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 저장할 임시 환자 정보 전체 개수 */
    totalTargetCount: number;
    /** 일괄 처리 작업 ID — 해당 아이디로 일괄 처리 작업 상태를 조회할 수 있음 */
    bulkJobId: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PatientControllerStartBulkImportBodyRequest {
  /** 병원 ID */
  hospitalID: string;
  /** 업로드된 엑셀 파일의 S3 객체 키 */
  s3Key: string;
  /** 업로드된 고객에게 상담 자동화를 적용할지 여부. 기본값은 false 입니다. */
  applyConsultationAutomation?: boolean;
  /** 업로드된 고객에게 치료 주의사항을 발송할지 여부. 기본값은 false 입니다. */
  sendTreatmentCaution?: boolean;
}

export interface PatientControllerStartBulkImportResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 검증 통과 여부 */
    valid: boolean;
    /** 검증 통과 시 발급되는 처리 job ID */
    jobId?: string;
    /** 검증 실패 시 행번호(문자열) → 오류 컬럼 레이블 배열 */
    rowErrors?: Record<string, string[]>;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PatientControllerFindPatientDetailResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    patientId: string;
    userID?: string;
    name?: string;
    chatRoom?: {
      id?: string;
      users?: {
        _id?: string;
        name?: string;
        realName?: string;
        type?: number;
        jobType?: string;
      }[];
      counselors?: {
        _id?: string;
        name?: string;
        realName?: string;
        type?: number;
        jobType?: string;
      }[];
      lastUserChat?: string;
    };
    recentChatRoom?: {
      id?: string;
      users?: {
        _id?: string;
        name?: string;
        realName?: string;
        type?: number;
        jobType?: string;
      }[];
      counselors?: {
        _id?: string;
        name?: string;
        realName?: string;
        type?: number;
        jobType?: string;
      }[];
      lastUserChat?: string;
    };
    recentChatRoomType?: string;
    hasSmartDoctorLinkage?: boolean;
    hasKakaoLinkage?: boolean;
    hasLinkedChatrooms?: boolean;
    hasInstagramLinkage?: boolean;
    hasTalkTalkLinkage?: boolean;
    hasLineLinkage?: boolean;
    hasWechatLinkage?: boolean;
    hasWhatsappLinkage?: boolean;
    isJoinedUserToAfterDoc?: boolean;
    linkType?: string;
    phoneNumber?: string;
    countryCode?: {
      id?: string;
      koreanCountryName?: string;
      internationalDialingCodes?: string;
    };
    birthdate?: string;
    gender?: string;
    treatmentTags?: {
      tagId?: string;
      name?: string;
      color?: string;
      automationApplied?: boolean;
      /** @format date-time */
      appliedAt?: string;
      folderID?: string;
      mappedDiagnosisCode?: string;
      isEditable?: boolean;
    }[];
    isFirstVisit?: boolean;
    chartNumber?: string;
    patientNote?: any;
    managerNote?: {
      managerNoteId?: string;
      content?: string;
      /** @format date-time */
      finalEditedAt?: string;
      finalEditorId?: string;
      finalEditorName?: string;
      isPinned?: boolean;
      images?: string[];
    };
    managementDirection?: {
      managementDirectionId?: string;
      content?: string;
      /** @format date-time */
      finalEditedAt?: string;
      finalEditorId?: string;
      finalEditorName?: string;
      isPinned?: boolean;
      images?: string[];
    };
    appliedAutomation?: {
      algorithmId?: string;
      algorithmName?: string;
      appliedNationalityNames?: string[];
      tagsHaveNoFolder?: {
        tagId?: string;
        tagName?: string;
        tagColor?: string;
      }[];
      tagsHaveFolder?: {
        folderID?: string;
        folderName?: string;
        tags?: {
          tagId?: string;
          tagName?: string;
          tagColor?: string;
        }[];
      }[];
    };
    hasAgreedPrivacyTerms?: boolean;
    isClosed?: boolean;
    closeReason?: string[];
    nationality?: {
      id?: string;
      koreanCountryName?: string;
    };
    ALCustomerNumber?: string;
    ALCustomerNumbers?: string[];
    hasPhoneChangeRequest?: boolean;
    isSuspendedByMobileApp?: boolean;
    appliedAutomations?: {
      _id?: string;
      algorithmType?: string;
      hospitalID?: string;
      hserviceID?: string;
      treatmentCategoryID?: {
        _id?: string;
        categoryName?: string;
        color?: string;
      };
      countryID?: {
        _id?: string;
        koreanCountryName?: string;
        internationalDialingCodes?: string;
        countryCodeISOAlpha2?: string;
        countryCodeISOAlpha3?: string;
      };
      algorithmID?: {
        _id?: string;
        name?: string;
        type?: string;
      };
      status?: string;
      terminateReason?: string;
      /** @format date-time */
      createdAt?: string;
      /** @format date-time */
      updatedAt?: string;
      /** @format date-time */
      startedAt?: string;
      /** @format date-time */
      terminatedAt?: string;
    }[];
    customTagGroups?: Record<
      string,
      {
        id?: string;
        name?: string;
        tags?: {
          id: string;
          name: string;
        }[];
      }
    >;
    hasToBlockSendingMessage?: boolean;
    tnhErmCustomerId?: string;
    tnhCustomerInfo?: {
      name?: string;
      phone?: string;
      birth?: string;
      chartNumber?: string;
      gender?: string;
    };
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PatientControllerGetDailyInfoHistoryResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 조회 결과 목록 */
    entries: {
      /** 스냅샷 _id */
      id: string;
      /** 환자 식별자 (HService._id) — 상세조회용 */
      patientId: string;
      /** savedAt → YYYY-MM-DD (KST) */
      date: string;
      /** 고객명 */
      name: string;
      /** 차트번호 */
      chartNumber: string | null;
      /** 전화번호 */
      phone: string;
      /** 생년월일 */
      birth: string | null;
      /** 'MALE' | 'FEMALE' | null (BE 저장값 그대로) */
      gender: string | null;
      /** 치료태그 목록 (태그 단위 자동화 적용 여부 포함) */
      treatmentTags: {
        /** 치료태그명 */
        name: string;
        /** 해당 태그에 상담자동화 적용 여부 */
        isAutomationApplied: boolean;
      }[];
      /** HService.createdAt 기반 신규고객 여부 */
      isNewCustomer: boolean;
      /** HService.closeReason 기반 이용중단 여부 */
      isClosed: boolean;
    }[];
    /** 요약 카운트 */
    counts: {
      /** 그날 전체 고객입력 수 (탭/검색 무관) */
      customerInput: number;
      /** 그날 신규고객 수 (탭/검색 무관) */
      newCustomer: number;
      /** 그날 치료태그가 추가된(마지막 상태 생존) 환자 수 */
      treatmentTag: number;
      /** 그날 상담자동화가 적용된(마지막 상태 생존) 환자 수 */
      automation: number;
    };
    /** 현재 탭/검색 적용 목록 총 건수 (페이징용) */
    total: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface HServiceMemoControllerFindOneResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  /** 고객 메모 문서. 없으면 빈 메모를 만들어 돌려준다 */
  data: {
    /** 메모 ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 병원서비스 ID */
    hserviceID: string;
    /** 환자의 유저 ID */
    userID: string;
    /** 메모 본문. 운영 문서의 92.86% 가 빈 문자열이다 */
    content: string;
    /** 작성자. 참조가 없으면 null */
    writerID?:
      | string
      | {
          /** 유저 ID */
          _id: string;
          /** 닉네임 */
          name?: string;
          /** 실명 */
          realName?: string;
          /** 유저 타입 */
          type?: number;
          /** 직무 */
          jobType?: string;
        };
    /** 작성자 타입 */
    writerType?: number | null;
    /** 수정자. 키 자체가 없는 문서가 있다 */
    modifierID?:
      | string
      | {
          /** 유저 ID */
          _id: string;
          /** 닉네임 */
          name?: string;
          /** 실명 */
          realName?: string;
          /** 유저 타입 */
          type?: number;
          /** 직무 */
          jobType?: string;
        };
    /** 수정자 타입 */
    modifierType?: number | null;
    /** 생성 일시 */
    createdAt: string;
    /** 마지막 수정 일시 */
    updatedAt: string;
    /** mongoose 버전 키. 문서 이력에 따라 없을 수 있다 */
    __v?: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface HServiceMemoControllerUpdateBodyRequest {
  /**
   * 병원 ID
   * @example "6732be0387ee3809f9d7632d"
   */
  hospitalID: string;
  /**
   * 병원서비스 ID
   * @example "6732be1387ee3809f9d76383"
   */
  hserviceID: string;
  /**
   * 환자의 유저 ID
   * @example "6732be2387ee3809f9d763a1"
   */
  userID: string;
  /**
   * 메모 본문. 주지 않거나 null 이면 빈 문자열로 저장된다
   * @example "어제 상담 내용"
   */
  content?: string;
}

export interface HServiceMemoControllerUpdateResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  /** 저장된 고객 메모 문서 */
  data: {
    /** 메모 ID */
    _id: string;
    /** 병원 ID */
    hospitalID: string;
    /** 병원서비스 ID */
    hserviceID: string;
    /** 환자의 유저 ID */
    userID: string;
    /** 메모 본문. 운영 문서의 92.86% 가 빈 문자열이다 */
    content: string;
    /** 작성자. 참조가 없으면 null */
    writerID?:
      | string
      | {
          /** 유저 ID */
          _id: string;
          /** 닉네임 */
          name?: string;
          /** 실명 */
          realName?: string;
          /** 유저 타입 */
          type?: number;
          /** 직무 */
          jobType?: string;
        };
    /** 작성자 타입 */
    writerType?: number | null;
    /** 수정자. 키 자체가 없는 문서가 있다 */
    modifierID?:
      | string
      | {
          /** 유저 ID */
          _id: string;
          /** 닉네임 */
          name?: string;
          /** 실명 */
          realName?: string;
          /** 유저 타입 */
          type?: number;
          /** 직무 */
          jobType?: string;
        };
    /** 수정자 타입 */
    modifierType?: number | null;
    /** 생성 일시 */
    createdAt: string;
    /** 마지막 수정 일시 */
    updatedAt: string;
    /** mongoose 버전 키. 문서 이력에 따라 없을 수 있다 */
    __v?: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface TemporaryPatientsIsLockHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hospitalID: string;
    isLock: boolean;
    version?: number;
    requestUserID?: {
      _id?: string;
      id?: string;
      realName?: string;
    } | null;
    /** @format date */
    updatedAt?: string;
    lockSource?: string;
    totalCount?: number;
    completedCount?: number;
    failedCount?: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface TemporaryPatientsRequestLockHandlerBodyRequest {
  hospitalID: string;
  version?: number;
  isLock?: boolean;
  lockSource?: string;
}

export interface TemporaryPatientsRequestLockHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    hospitalID: string;
    isLock: boolean;
    version?: number;
    lockSource?: string;
    requestUserID?: {
      _id?: string;
      id?: string;
      realName?: string;
    } | null;
    /** @format date */
    updatedAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface TemporaryPatientsLastModifierHandlerBodyRequest {
  hospitalID: string;
}

export interface TemporaryPatientsLastModifierHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    userID?: {
      _id?: string;
      id?: string;
      realName?: string;
    } | null;
    /** @format date */
    createdAt?: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface TemporaryPatientsProcessingBatchHandlerBodyRequest {
  /**
   * 발송할 시간
   * @format date
   * @example "2025-01-01T00:00:00.000Z"
   */
  targetDateTime?: string;
  /**
   * 대상 병원 ID 목록
   * @example ["63d7bafc1374672f7c407efd"]
   */
  targetHospitals?: string[];
  /**
   * 병원 시간대
   * @example "Asia/Seoul"
   */
  timezone?: string;
}

export interface TemporaryPatientsProcessingBatchHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 대상 병원 수
     * @example 10
     */
    targetTotalCount: number;
    /**
     * 성공한 병원 알림 처리 수
     * @example 10
     */
    successCount: number;
    /**
     * 알림 처리 스킵한 병원 수
     * @example 0
     */
    skipCount: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface TempPatientsProcessingBatchHandlerBodyRequest {
  /**
   * 발송할 시간
   * @format date
   * @example "2025-01-01T00:00:00.000Z"
   */
  targetDateTime?: string;
  /**
   * 대상 병원 ID 목록
   * @example ["63d7bafc1374672f7c407efd"]
   */
  targetHospitals?: string[];
  /**
   * 병원 시간대
   * @example "Asia/Seoul"
   */
  timezone?: string;
  /**
   * 메시지 발송 생략 여부
   * @example false
   */
  skipSendingMessage?: boolean;
  /**
   * 처리를 생략할 휴대폰 번호 목록
   * @example ["01012345678"]
   */
  toBeSkippedProcessingPhoneNumbers?: string[];
}

export interface TempPatientsProcessingBatchHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 대상 임시 환자 데이터 수
     * @example 1000
     */
    totalTargetCount: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ElFindLinkedChatroomsHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    _id: string;
    title: string;
    roomType: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
    isCounselInProgress?: boolean;
    usingTranslation?: boolean;
    users: string[];
    counselors: {
      /** MongoDB Identifier */
      _id: string;
      /** 실 이름 */
      realName: string;
      /** 유저가 보는 이름 */
      name: string;
      /**
       * 유저의 타입.
       * 1000 = 환자
       * 2xxx = 병원 유저
       *  3xxx = 메디팔 유저
       */
      type: number;
      /** 병원내 계정의 직/직책 */
      jobType: string;
    }[];
    ikakaoinfo?: {
      pf_id?: string;
      user_key?: string;
      isClosed?: boolean;
      isUnauthorized?: boolean;
    };
    lastMessage: {
      type: number;
      userType: number;
      content?: string;
      translatedContent?: string;
      retranslatedContent?: string;
      isTranslated?: boolean;
      userName?: string;
      userRealName?: string;
      isSent?: boolean;
      isSendContent?: boolean;
      /** @format date */
      sentAt?: string;
    };
    /** @format date */
    lastMessageUpdatedAt?: string;
    /** 채팅방 참여 여부 */
    isParticipating: boolean;
    /** 연동된 채널명 */
    channelName?: string;
  }[];
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ServiceRegistrationBySocialChannelHandlerBodyRequest {
  /**
   * 채널 타입
   * @example "ikakao"
   */
  channelType: "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 환자 이름
   * @example "김애프터닥"
   */
  name: string;
  /**
   * 환자 전화번호
   * @example "01012345678"
   */
  phone: string;
  /**
   * 국가 코드 ID
   * @example "66a9d85407a37e99d4ae625f"
   */
  countryCodeID: string;
  /**
   * 기존 서비스 ID. 제공 시 이름, 휴대폰번호, 국가코드 기반 신규/기존 서비스 판별을 건너뛰고 해당 서비스에 바로 채널 연결을 수행
   * @example "674d7c77a5715809859efd4c"
   */
  hserviceID?: string;
  /**
   * 채팅방 ID
   * @example "674d7c77a5715809859efd4c"
   */
  chatRoomID?: string;
  /**
   * 카카오 상담 채널 ID
   * @example "1234567890"
   */
  pf_id?: string;
  /**
   * 환자 고유 카카오톡 유저 키
   * @example "abcdefg1234567"
   */
  user_key?: string;
  /**
   * 광고성 메시지 수신 거부 여부
   * @example false
   */
  hasToBlockSendingMessage?: boolean;
}

export interface ServiceRegistrationBySocialChannelHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** MongoDB Identifier */
    _id: string;
    /** 서비스 대상이 되는 유저 ID */
    userID: string;
    name: string;
    birth: string;
    phone: string;
    countryCode?: string;
    gender: string;
    chartNumber: string;
    nurseID: string;
    nurseIDs?: string[];
    doctorID: string;
    hospitalID?: {
      /** MongoDB Identifier */
      _id: string;
      shortName: string;
      address?: string;
      introduction: string;
      representImage?: {
        /** MongoDB Identifier */
        _id: string;
        paths: string[];
        aws?: {
          ETag: string;
          Location: string;
          Key: string;
          key: string;
          size?: {
            width?: number;
            height?: number;
          } | null;
          fileSize: number;
          fileName: string;
        }[];
      };
      representUser?: string;
      homepageURL?: string;
      phone?: string;
      isHiddenPhoneNumber?: boolean;
      usingHomepage?: boolean;
      careSchedule: {
        dayIndex?: number;
        /** @format date */
        startedAt?: string;
        /** @format date */
        endedAt?: string;
      }[];
      careScheduleDescription: string;
      nurseID?: string;
      isSecondEdition?: boolean;
      usingVideoContent?: boolean;
      usingHospitalEvent?: boolean;
      healthContentCategory: string[];
      usingHealthContent?: boolean;
      usingHospitalContent?: boolean;
      integrationSetting?: {
        hospitalID: string;
        clientToken?: string;
        integrationType?: string;
        customObject?: {
          defaultLabelID?: string[];
          defaultCancelID?: string[];
        };
        usingRegist?: boolean;
        usingReservation?: boolean;
        usingDashboard?: boolean;
        isRemoved: boolean;
        /** @format date */
        createdAt?: string;
        /** @format date */
        updatedAt?: string;
      };
      usingAfterhoursPopup?: boolean;
      afterhoursPopupContent?: string;
      usingV2ReservationSheet?: boolean;
      usingSaaSReservation?: boolean;
      isEnabledSaaS?: boolean;
      countryIds?: string[];
      /** @format date */
      createdAt: string;
      /** @format date */
      updatedAt?: string;
    };
    chatRoomID?: {
      /** MongoDB Identifier */
      _id: string;
      hserviceID: string;
      users?: string[];
      userID: string;
      title: string;
      n_UnreadCount: number;
      c_UnreadCount: number;
      c_isFirstEnter: boolean;
      c_isFirstNurseChat: boolean;
      c_isFirstUserChat: boolean;
      c_isSendedFirstNursechat: boolean;
      hospitalID: string;
      isDoctor: boolean;
      hasFirstSMS: boolean;
      lastMessage?: string;
      /** @format date */
      lastMessageUpdatedAt?: string;
      lastNurseChat?: string;
      /** @format date */
      lastNurseChatUpdatedAt?: string;
      badgeCountInfo?: Record<string, number>;
      info?: {
        userID: string;
        count: number;
        title: string;
      }[];
      isMultiUser?: boolean;
      isChatResponseRequired?: boolean;
      hasUnreadChatResponseRequired?: boolean;
      isRemoved?: boolean;
      roomType?: "patient" | "manager" | "ikakao" | "instagram" | "talktalk" | "line" | "wechat" | "whatsapp";
      ikakaoinfo?: {
        pf_id?: string;
        user_key?: string;
        isClosed?: boolean;
        isUnauthorized?: boolean;
      };
      lineInfo?: {
        lineUserId?: string;
        isClosed?: boolean;
        closedReason?: string;
        lineConsultMapID?: string;
        lineChannelName?: string;
        lineBotID?: string;
      };
      wechatInfo?: {
        channelID?: string;
        channelName?: string;
        userID?: string;
        isClosed?: boolean;
        closedReason?: "USER_UNSUBSCRIBED";
      };
      counselors?: string[];
      isCounselInProgress?: boolean;
      usingTranslation?: boolean;
      languageID?: string;
      isActive?: boolean;
      parentHServiceID?: string;
      isClosed?: boolean;
      /** @format date */
      createdAt: string;
      /** @format date */
      updatedAt: string;
    };
    ALCustomerNumber: string;
    ALCustomerNumbers?: string[];
    memos?: string[];
    managementDiaries?: string[];
    userTagIDs?: string[];
    hasPatientSetting: boolean;
    initialTreatments?: string[];
    etcTreatments: string;
    hasUnreadNurseMemo: boolean;
    hasUnreadDoctorMemo: boolean;
    shortLinkID: string;
    linkType: string;
    description: string;
    classificationNote1: string;
    classificationNote2: string;
    new: boolean;
    status: string;
    isRun: boolean;
    isClosed: boolean;
    closeReason?: string[];
    /** @format date */
    agree_terms: string;
    /** @format date */
    agree_privacy: string;
    /** @format date */
    agree_sensitive: string;
    /** @format date */
    joinedAt: string;
    /** @format date */
    lastLogin: string;
    lastUserChat?: string;
    /** @format date */
    lastUserChatDate?: string;
    hasLastUserChat?: boolean;
    lastNurseChat?: string;
    /** @format date */
    lastNurseChatDate?: string;
    hasLastNurseChat?: boolean;
    lastMessage?: string;
    /** @format date */
    lastMessageUpdatedAt?: string;
    /** @format date */
    lastSMSDate?: string;
    treatmentCategories?: string[];
    /** @format date */
    treatmentStartDate: string;
    isFirstvisit: boolean;
    isTest: boolean;
    isUnregisteredUser: boolean;
    reservedVCHIDs?: string[];
    vccIDs?: string[];
    /** @format date */
    lastVCUDate: string;
    /** @format date */
    lastVCUEndDate: string;
    hasVCU: boolean;
    isOverHCompletionRate: boolean;
    isVCUOngoing: boolean;
    sumShareCount: number;
    avgCompletionRate: number;
    needVCU: boolean;
    hasTrophy: boolean;
    sortDigitVC: string;
    seq: number;
    hasSmartDoctorLinkage: boolean;
    hasKakaoLinkage: boolean;
    /** @format date */
    createdAt: string;
    /** @format date */
    updatedAt: string;
    /** @format date */
    startedAt: string;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface InSejongPatientsHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /**
     * 성공 여부
     * @example true
     */
    isSuccess: boolean;
    /**
     * 갱신된 임시 환자 데이터 수
     * @example 10
     */
    renewedCount: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PatientTreatmentTagHistoriesFindHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: | {
        /** 치료태그 변경 이력 ID */
        _id?: string;
        /** 병원 ID */
        hospitalID?: string;
        /** 병원 서비스 ID */
        hserviceID?: string;
        /** 치료태그 목록 */
        histories?: {
          /** 치료태그 개별 추가 이력 ID */
          _id?: string;
          /** 치료태그명 */
          categoryName?: string;
          /** 치료태그 액션 타입: ADD(추가), ADD_AND_APPLY_AUTOMATION(자동화 적용 및 추가), REMOVE(제거) */
          action: "ADD" | "ADD_AND_APPLY_AUTOMATION" | "REMOVE";
        }[];
        /** 수정자 이름 */
        writerName?: string;
        /** 치료태그 입력 진입점: SINGLE/BULK/BULK_YESTERDAY/EXCEL_UPLOAD/DETAIL/UNTAGGED */
        source?: string;
        /** 생성 일시 - 정렬용 key로 사용 */
        createdAt?: string;
        /** 수정 일시 */
        updatedAt?: string;
      }[]
    | null;
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface PatientTreatmentTagHistoriesCountHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 치료태그 변경 이력 개수 */
    count?: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ExportTempPatientsByRefKeyHandlerResponse {
  /** 응답 코드 (0=성공, 그외=오류) */
  code: number;
  data: {
    /** 엑셀 다운로드용 환자 데이터 목록 */
    patients: {
      /**
       * 순서
       * @example 1
       */
      order: number;
      /**
       * 이름
       * @example "김애프터닥"
       */
      name?: string | null;
      /**
       * 전화번호
       * @example "01012345678"
       */
      phoneNumber?: string | null;
      /**
       * 국가 코드
       * @example "대한민국"
       */
      countryCode?: string | null;
      /**
       * 생년월일
       * @example "1990-01-01"
       */
      birth?: string | null;
      /**
       * 성별 (M/F)
       * @example "M"
       */
      gender?: string | null;
      /** 치료 태그 배열 */
      treatmentCategories?: string[] | null;
      /** 고객 태그 배열 */
      customTagIDs?:
        | {
            customTagGroupID: {
              /**
               * 태그 그룹 ID
               * @example "63d7bafc1374672f7c407efd"
               */
              _id: string;
              /**
               * 태그 그룹 이름
               * @example "그룹명"
               */
              name: string;
            };
            /**
             * 태그 이름
             * @example "Welcome"
             */
            name: string;
          }[]
        | null;
      /**
       * 초진 여부
       * @example true
       */
      isFirstVisit?: boolean | null;
      /**
       * 차트 번호
       * @example "CH001"
       */
      chartNumber?: string | null;
      /**
       * 국적
       * @example "대한민국"
       */
      nationality?: string | null;
      /**
       * 광고성문자 수신동의
       * @example false
       */
      hasToBlockSendingMessage?: boolean | null;
    }[];
    /**
     * 실패한 환자 수
     * @example 100
     */
    failedCount: number;
  };
  /** 응답 메세지. 응답 코드가 0이 아닌 경우 오류 메세지 */
  message: string;
}

export interface ApiPatientsElDetailParams {
  /** (required) 환자 ID */
  patientId: string;
}

export type ApiPatientsElDetailData = ApiResponse & {
  data: {
    /** 환자 고유 ID */
    patientId: string;
    /** 환자의 User ID */
    userID?: string;
    /** 환자 이름 */
    name: string;
    /** 채팅방 정보 */
    chatRoom: {
      /** 채팅방 ObjectId */
      id: string;
      /** 참여자 ObjectId 배열 */
      users: {
        _id: string;
        name: string;
        realName?: string;
        type: number;
        jobType?: string;
      }[];
      /** 담당자 ObjectId 배열 */
      counselors: {
        _id: string;
        name: string;
        realName?: string;
        type: number;
        jobType?: string;
      }[];
      /** 유저가 작성한 마지막 채팅 ObjectId */
      lastUserChat?: string;
    };
    /** 가장 최근에 활성화된 채팅방 정보 */
    recentChatRoom: {
      /** 채팅방 ObjectId */
      id: string;
      /** 참여자 ObjectId 배열 */
      users: {
        _id: string;
        name: string;
        realName?: string;
        type: number;
        jobType?: string;
      }[];
      /** 담당자 ObjectId 배열 */
      counselors: {
        _id: string;
        name: string;
        realName?: string;
        type: number;
        jobType?: string;
      }[];
      /** 유저가 작성한 마지막 채팅 ObjectId */
      lastUserChat?: string;
    };
    /** 마지막으로 활성화된 채팅방 타입 */
    recentChatRoomType?: string;
    /** 스마트닥터 연동 여부 */
    hasSmartDoctorLinkage?: boolean;
    /** 카카오 연동 여부 */
    hasKakaoLinkage?: boolean;
    /** 인스타그램 연동 여부 */
    hasInstagramLinkage?: boolean;
    /** 톡톡 연동 여부 */
    hasTalkTalkLinkage?: boolean;
    /** 라인 연동 여부 */
    hasLineLinkage?: boolean;
    /** 위챗 연동 여부 */
    hasWechatLinkage?: boolean;
    /** Whatsapp 연동 여부 */
    hasWhatsappLinkage?: boolean;
    /** 연동된 채팅방 존재 여부 */
    hasLinkedChatrooms?: boolean;
    /** 애프터닥 가입 여부 */
    isJoinedUserToAfterDoc?: boolean;
    /** 애프터닥 가입 링크 타입 */
    linkType?: number;
    /** 전화번호 */
    phoneNumber: string;
    /** 국가 번호 정보 */
    countryCode?: {
      /** 국가/국적 ID */
      id: string;
      /**
       * 한국어 국가명
       * @example "중국, 일본, 미국, 러시아"
       */
      koreanCountryName: string;
      /** 국제 전화 코드 */
      internationalDialingCodes: string;
    };
    /**
     * 생년월일
     * @format date
     */
    birthdate?: string;
    /** 성별 */
    gender?: "MALE" | "FEMALE";
    /** 치료 태그 목록 */
    treatmentTags?: TreatmentTag[];
    /** 초진 여부 */
    isFirstVisit?: boolean;
    /** 차트 번호 */
    chartNumber?: string;
    /** 대표 전능연동 차트 번호 */
    ALCustomerNumber?: string;
    /** 전능연동 차트 번호 배열 */
    ALCustomerNumbers?: string[];
    /** 전화번호 변경 요청 존재 여부 */
    hasPhoneChangeRequest?: boolean;
    /** 고객이 직접 이용 중단 여부 */
    isSuspendedByMobileApp?: boolean;
    /** 고객 메모 객체 */
    patientNote?: HServiceMemoWriterModifier;
    /** Vegas ERM 고객 ID */
    tnhErmCustomerId?: string;
    tnhCustomerInfo?: {
      /** 고객 이름 */
      name?: string;
      /** 고객 전화번호 */
      phone?: string;
      /** 고객 생년월일 */
      birth?: string;
      /** 고객 차트번호 */
      chartNumber?: string;
      /** 고객 성별 */
      gender?: string;
    };
    managerNote?: {
      /** 관리자 노트 ID */
      managerNoteId: string;
      /** 노트 내용 */
      content: string;
      /**
       * 최종 수정 시간
       * @format date-time
       */
      finalEditedAt: string;
      /** 최종 수정자 ID */
      finalEditorId: string;
      /** 최종 수정자 이름 */
      finalEditorName: string;
      /** 고정 여부 */
      isPinned: boolean;
      /** 이미지 URL 목록 */
      images?: string[];
    };
    managementDirection?: {
      /** 원장님 관리 방향 ID */
      managementDirectionId: string;
      /** 관리 방향 내용 */
      content: string;
      /**
       * 최종 수정 시간
       * @format date-time
       */
      finalEditedAt: string;
      /** 최종 수정자 ID */
      finalEditorId: string;
      /** 최종 수정자 이름 */
      finalEditorName: string;
      /** 고정 여부 */
      isPinned: boolean;
      /** 이미지 URL 목록 */
      images?: string[];
    };
    appliedAutomation?: OngoingAutomation;
    /**
     * 개인정보보호 약관 동의 여부
     * @default true
     */
    hasAgreedPrivacyTerms: boolean;
    /**
     * 환자의 서비스 중단 상태 여부
     * @default false
     */
    isClosed: boolean;
    /** 서비스 종료시 사용자가 선택한 서비스 종료 이유. 혹은 병원에서 서비스를 종료한 후 사용자에게 보여주기 위한 문구. */
    closeReason?: any[];
    nationality?: {
      /** 국가/국적 ID */
      id: string;
      /**
       * 한국어 국가명
       * @example "중국, 일본, 미국, 러시아"
       */
      koreanCountryName: string;
    };
    appliedAutomations?: {
      /** 적용된 자동화 객체 ID */
      _id: string;
      algorithmType?: "CONSULTATION" | "MARKETING";
      /** 병원 ID */
      hospitalID: string;
      /** 자동화가 적용된 HService ID */
      hserviceID: string;
      /** 해당 자동화를 트리거하게 된 TreatmentCategory 객체 */
      treatmentCategoryID?: {
        /** 치료태그의 ID */
        _id?: string;
        /** 치료태그의 이름 */
        categoryName?: string;
        /** 치료태그의 색상의 hex 코드 */
        color?: string;
      };
      /** 해당 자동화를 트리거하게 된 국가 정보 */
      countryID?: {
        /** 국가코드 ID */
        _id?: string;
        /** 국가코드의 한국어 명 */
        koreanCountryName?: string;
        /** 해당 국가의 전화번호 접두 */
        internationalDialingCodes?: string;
        /** 해당 국가의 2자리 알파뱃 코드 */
        countryCodeISOAlpha2?: string;
        /** 해당 국가의 3자리 알파뱃 코드 */
        countryCodeISOAlpha3?: string;
      };
      /** 자동화 객체 정보 */
      algorithmID?: {
        /** 자동화 ID */
        _id?: string;
        /** 자동화의 이름 */
        name?: string;
        /** 자동화의 타입 구분 */
        type?: "CONSULTATION" | "MARKETING";
      };
      /** 해당 자동화의 상태 */
      status?: "PROGRESS" | "PAUSE" | "STOP" | "COMPLATE";
      /** 상태의 값이 stop인 경우 해당 사유 */
      terminateReason?: string;
      /** 생성일 */
      createdAt?: string;
      /** 마지막 수정일 */
      updatedAt?: string;
      /** 해당 자동화의 시작일시 */
      startedAt?: string;
      /** 해당 자동화의 종료일시 */
      terminatedAt?: string;
    }[];
    /** 고객 태그 그룹 객체 (태그 그룹 ID를 키로 사용) */
    customTagGroups?: Record<
      string,
      {
        /** 태그 그룹 이름 */
        name: string;
        /**
         * 태그 그룹 생성일시
         * @format date-time
         */
        createdAt: string;
        /** 해당 그룹에 속한 고객 태그 목록 */
        tags: {
          /** 고객 태그 ID */
          id: string;
          /** 고객 태그 이름 */
          name: string;
        }[];
      }
    >;
    /** 마케팅 수신 동의 여부 */
    hasToBlockSendingMessage: boolean;
  };
};

export interface ApiPatientsElListOrSearchParams {
  /** 병원 아이디 */
  hospitalID: string;
  /**
   * 페이지 번호
   * @default 1
   */
  page?: number;
  /**
   * 한 페이지당 환자 수 (기본값 = 20)
   * @default 20
   */
  limit?: number;
  /**
   * 조회 대상 (ALL=전체, JOINED=가입된 환자, NOT-REGISTERED=미가입 환자)
   * @default "ALL"
   */
  target: "ALL" | "JOINED" | "NOT-REGISTERED";
  /** 요청 목적 (COMMON=일반적인 환자 조회, ONGOING-AUTOMATION=진행 중인 상담 자동화가 있는 환자 조회) */
  "request-purpose": "COMMON" | "ONGOING-AUTOMATION";
  /** 환자명(또는 기획서 상 고객명) - ',' 로 구분하여 여러명 검색 불가 */
  patientName?: string;
  /** 차트번호 - ',' 로 구분하여 여러명 검색 불가 */
  chartNumber?: string;
  /** 초진 여부 - 재진일 경우 false, 초진일 경우 true */
  isFirstVisit?: boolean;
  /** 휴대폰번호 - ',' 로 구분하여 여러명 검색 불가 */
  phone?: string;
  /** 생년월일 - ',' 로 구분하여 여러명 검색 불가 */
  birth?: string;
  /** 성별 - ',' 로 구분하여 여러명 검색 불가 */
  gender?: "MALE" | "FEMALE";
  /** 치료 태그 아이디 리스트 - ',' 로 구분하여 여러 치료태그에 대해서 검색 가능 */
  treatmentCategories?: string;
  /** 적용된 상담 자동화 알고리즘 아이디. _id 값을 ObjectId 문자열 그대로 넣어주세요. 검색용 필드가 아닌 조회용 필드입니다. request-purpose 가 ONGOING-AUTOMATION 일 때만 사용 가능하고 그 경우에는 비어있으면 안돼요. */
  appliedConsultationAlgorithmId?: string;
  /** 국적 아이디 리스트 - ',' 로 구분하여 여러 국적에 대해서 검색 가능 */
  nationality?: string;
  /** 국가 코드 아이디 리스트 - ',' 로 구분하여 여러 국가 코드에 대해서 검색 가능 */
  countryCode?: string;
  /** 고객 태그. _id 값을 ObjectId 문자열 그대로 넣어주세요. - ',' 로 구분하여 다중 검색 가능 */
  customTagIDs?: string;
}

export type ApiPatientsElListOrSearchData = ApiResponse & {
  data: {
    /** 전체 환자 수 */
    totalCount: number;
    /** 전체 페이지 수 */
    totalPages: number;
    /** 현재 페이지 번호 */
    currentPage: number;
    /** 한 페이지당 환자 수 */
    limit: number;
    /** 다음 페이지 존재 여부 */
    hasNextPage: boolean;
    /** 환자 목록 */
    patients?: {
      /** 환자 고유 ID */
      patientId: string;
      /** 환자 이름 */
      name: string;
      /** 스마트닥터 연동 여부 */
      hasSmartDoctorLinkage?: boolean;
      /** 카카오 연동 여부 */
      hasKakaoLinkage?: boolean;
      /** 인스타그램 연동 여부 */
      hasInstagramLinkage?: boolean;
      /** 톡톡 연동 여부 */
      hasTalkTalkLinkage?: boolean;
      /** 라인 연동 여부 */
      hasLineLinkage?: boolean;
      /** 위챗 연동 여부 */
      hasWechatLinkage?: boolean;
      /** 왓츠앱 연동 여부 */
      hasWhatsappLinkage?: boolean;
      /** 애프터닥 가입 여부 */
      isJoinedUserToAfterDoc?: boolean;
      /** 애프터닥 가입 링크 타입 */
      linkType?: number;
      /** 전화번호 */
      phoneNumber: string;
      countryCode?: {
        /** 국가/국적 ID */
        id: string;
        /** 한국어 국가명 */
        koreanCountryName: string;
        /** 영어 국가명 */
        englishCountryName: string;
        /** 국제 전화 코드 */
        internationalDialingCodes: string;
      };
      /**
       * 생년월일
       * @format date
       */
      birthdate?: string;
      /** 성별 */
      gender?: "MALE" | "FEMALE";
      /** 치료 태그 목록 */
      treatmentTags?: (TreatmentTag & any)[];
      /** 초진 여부 */
      isFirstVisit?: boolean;
      /** 차트 번호 */
      chartNumber?: string;
      /** 가입 상태 플래그. pending - 미가입, run - 가입, closed - 이용중단 */
      status: "pending" | "run" | "closed";
      /** 이용중단 여부 */
      isClosed: boolean;
      /** 고객이 직접 이용 중단 여부 */
      isSuspendedByMobileApp?: boolean;
      /** Vegas ERM 고객 ID */
      tnhErmCustomerId?: string;
      /** Vegas ERM 고객정보 */
      tnhCustomerInfo?: {
        /** 고객 이름 */
        name?: string;
        /** 고객 전화번호 */
        phone?: string;
        /** 고객 생년월일 */
        birth?: string;
        /** 고객 차트번호 */
        chartNumber?: string;
        /** 고객 성별 */
        gender?: string;
      };
      nationality?: {
        /** 국가/국적 ID */
        id: string;
        /** 한국어 국가명 */
        koreanCountryName: string;
        /** 영어 국가명 */
        englishCountryName: string;
      };
      /** 고객 태그 목록 (GroupId를 키로 하는 객체) */
      customTags?: Record<
        string,
        {
          /** 고객 태그 ID */
          tagId: string;
          /** 고객 태그 이름 */
          name: string;
        }[]
      >;
    }[];
  };
};

export interface ApiPatientsElListOrSearchForUntaggedParams {
  /** 병원 아이디 */
  hospitalID: string;
  /** 커서 (patientId). 최초 호출 이후 응답 값에 nextCursor 값이 주어집니다. */
  cursor?: string;
  /**
   * 한 페이지당 환자 수 (기본값 = 20)
   * @default 20
   */
  limit?: number;
  /** 환자명(또는 기획서 상 고객명) - ',' 로 구분하여 여러명 검색 불가 */
  patientName?: string;
  /** 차트번호 - ',' 로 구분하여 여러명 검색 불가 */
  chartNumber?: string;
  /** 초진 여부 (true=초진, false=재진) - ',' 로 구분하여 여러명 검색 불가 */
  isFirstVisit?: boolean;
  /** 휴대폰번호 - ',' 로 구분하여 여러명 검색 불가 */
  phone?: string;
  /** 성별 (MALE=남성, FEMALE=여성) - ',' 로 구분하여 여러명 검색 불가 */
  gender?: "MALE" | "FEMALE";
  /** 치료 태그 아이디 리스트 - ',' 로 구분하여 여러 치료태그에 대해서 검색 가능 */
  treatmentCategories?: string;
  /** 국적 아이디 리스트 - ',' 로 구분하여 여러 국적에 대해서 검색 가능 */
  nationality?: string;
  /** 국가 코드 아이디 리스트 - ',' 로 구분하여 여러 국가 코드에 대해서 검색 가능 */
  countryCode?: string;
  /** 고객 태그. _id 값을 ObjectId 문자열 그대로 넣어주세요. - ',' 로 구분하여 다중 검색 가능 */
  customTagIDs?: string;
}

export type ApiPatientsElListOrSearchForUntaggedData = ApiResponse & {
  data: {
    /** 전체 환자 수 */
    totalCount: number;
    /** 한 페이지당 환자 수 */
    limit: number;
    /** 다음 페이지 존재 여부 */
    hasNextPage: boolean;
    /** 다음 페이지에서 조회할 첫 번째 환자 아이디 */
    nextCursor: string;
    /** 환자 목록 */
    patients?: {
      /** 환자 고유 ID */
      patientId: string;
      /** 환자 이름 */
      name: string;
      /** 스마트닥터 연동 여부 */
      hasSmartDoctorLinkage?: boolean;
      /** 카카오 연동 여부 */
      hasKakaoLinkage?: boolean;
      /** 톡톡 연동 여부 */
      hasTalkTalkLinkage?: boolean;
      /** 라인 연동 여부 */
      hasLineLinkage?: boolean;
      /** 애프터닥 가입 여부 */
      isJoinedUserToAfterDoc?: boolean;
      /** 애프터닥 가입 링크 타입 */
      linkType?: number;
      /** 전화번호 */
      phoneNumber: string;
      countryCode?: {
        /** 국가/국적 ID */
        id: string;
        /** 한국어 국가명 */
        koreanCountryName: string;
        /** 영어 국가명 */
        englishCountryName: string;
        /** 국제 전화 코드 */
        internationalDialingCodes: string;
      };
      /**
       * 생년월일
       * @format date
       */
      birthdate?: string;
      /** 성별 */
      gender?: "MALE" | "FEMALE";
      /** 치료 태그 목록 */
      treatmentTags?: (TreatmentTag & any)[];
      /** 초진 여부 */
      isFirstVisit?: boolean;
      /** 차트 번호 */
      chartNumber?: string;
      /** 고객 태그 목록 (GroupId를 키로 하는 객체) */
      customTags?: Record<
        string,
        {
          /** 고객 태그 ID */
          tagId: string;
          /** 고객 태그 이름 */
          name: string;
        }[]
      >;
      /** 가입 상태 플래그. pending - 미가입, run - 가입, closed - 이용중단 */
      status: "pending" | "run" | "closed";
      nationality?: {
        /** 국가/국적 ID */
        id: string;
        /** 한국어 국가명 */
        koreanCountryName: string;
        /** 영어 국가명 */
        englishCountryName: string;
      };
    }[];
  };
};

export interface ApiPatientsElUntaggedCountParams {
  /** 병원 아이디 */
  hospitalID: string;
}

export type ApiPatientsElUntaggedCountData = ApiResponse & {
  data: {
    /** 태그 미등록 환자 수 */
    count?: number;
  };
};

export type ApiPatientsElCountData = ApiResponse & {
  data: {
    /** 전체 환자(고객) 수 */
    count?: number;
  };
};

export type ApiPatientsElUntaggedTargetData = ApiResponse & {
  data: {
    /** 성공적으로 태그가 등록된 환자 수 */
    successCount: number;
    /** 태그 등록에 실패한 환자 수 */
    failCount: number;
  };
};

export type ApiPatientsElUpsertSingleData = ApiResponse & {
  data: {
    /**
     * 고객 정보 수정 성공 여부
     * @example true
     */
    isUpdatedSuccess: boolean;
    /**
     * 휴대폰 번호 변경 여부
     * @example false
     */
    isPhoneChanged: boolean;
  };
};

export type ApiPatientsElTemporaryV2ReservationTodayData = ApiResponse & {
  data: HServiceTempPatient[];
};

export interface ApiPatientsHmDetailParams {
  /** (required) 환자 ID */
  patientId: string;
}

export type ApiPatientsHmDetailData = ApiResponse & {
  data: {
    /** 환자 고유 ID */
    patientId: string;
    /** 환자의 User ID */
    userID?: string;
    /** 환자 이름 */
    name: string;
    /** 채팅방 정보 */
    chatRoom: {
      /** 채팅방 ObjectId */
      id: string;
      /** 참여자 ObjectId 배열 */
      users: {
        _id: string;
        name: string;
        realName?: string;
        type: number;
        jobType?: string;
      }[];
      /** 담당자 ObjectId 배열 */
      counselors: {
        _id: string;
        name: string;
        realName?: string;
        type: number;
        jobType?: string;
      }[];
      /** 유저가 작성한 마지막 채팅 ObjectId */
      lastUserChat?: string;
    };
    /** 가장 최근에 활성화된 채팅방 정보 */
    recentChatRoom: {
      /** 채팅방 ObjectId */
      id: string;
      /** 참여자 ObjectId 배열 */
      users: {
        _id: string;
        name: string;
        realName?: string;
        type: number;
        jobType?: string;
      }[];
      /** 담당자 ObjectId 배열 */
      counselors: {
        _id: string;
        name: string;
        realName?: string;
        type: number;
        jobType?: string;
      }[];
      /** 유저가 작성한 마지막 채팅 ObjectId */
      lastUserChat?: string;
    };
    /** 마지막으로 활성화된 채팅방 타입 */
    recentChatRoomType?: string;
    /** 스마트닥터 연동 여부 */
    hasSmartDoctorLinkage?: boolean;
    /** 카카오 연동 여부 */
    hasKakaoLinkage?: boolean;
    /** 인스타그램 연동 여부 */
    hasInstagramLinkage?: boolean;
    /** 톡톡 연동 여부 */
    hasTalkTalkLinkage?: boolean;
    /** 라인 연동 여부 */
    hasLineLinkage?: boolean;
    /** 위챗 연동 여부 */
    hasWechatLinkage?: boolean;
    /** Whatsapp 연동 여부 */
    hasWhatsappLinkage?: boolean;
    /** 연동된 채팅방 존재 여부 */
    hasLinkedChatrooms?: boolean;
    /** 애프터닥 가입 여부 */
    isJoinedUserToAfterDoc?: boolean;
    /** 애프터닥 가입 링크 타입 */
    linkType?: number;
    /** 전화번호 */
    phoneNumber: string;
    /** 국가 번호 정보 */
    countryCode?: {
      /** 국가/국적 ID */
      id: string;
      /**
       * 한국어 국가명
       * @example "중국, 일본, 미국, 러시아"
       */
      koreanCountryName: string;
      /** 국제 전화 코드 */
      internationalDialingCodes: string;
    };
    /**
     * 생년월일
     * @format date
     */
    birthdate?: string;
    /** 성별 */
    gender?: "MALE" | "FEMALE";
    /** 치료 태그 목록 */
    treatmentTags?: TreatmentTag[];
    /** 초진 여부 */
    isFirstVisit?: boolean;
    /** 차트 번호 */
    chartNumber?: string;
    /** 대표 전능연동 차트 번호 */
    ALCustomerNumber?: string;
    /** 전능연동 차트 번호 배열 */
    ALCustomerNumbers?: string[];
    /** 전화번호 변경 요청 존재 여부 */
    hasPhoneChangeRequest?: boolean;
    /** 고객이 직접 이용 중단 여부 */
    isSuspendedByMobileApp?: boolean;
    /** 고객 메모 객체 */
    patientNote?: HServiceMemoWriterModifier;
    managerNote?: {
      /** 관리자 노트 ID */
      managerNoteId: string;
      /** 노트 내용 */
      content: string;
      /**
       * 최종 수정 시간
       * @format date-time
       */
      finalEditedAt: string;
      /** 최종 수정자 ID */
      finalEditorId: string;
      /** 최종 수정자 이름 */
      finalEditorName: string;
      /** 고정 여부 */
      isPinned: boolean;
      /** 이미지 URL 목록 */
      images?: string[];
    };
    managementDirection?: {
      /** 원장님 관리 방향 ID */
      managementDirectionId: string;
      /** 관리 방향 내용 */
      content: string;
      /**
       * 최종 수정 시간
       * @format date-time
       */
      finalEditedAt: string;
      /** 최종 수정자 ID */
      finalEditorId: string;
      /** 최종 수정자 이름 */
      finalEditorName: string;
      /** 고정 여부 */
      isPinned: boolean;
      /** 이미지 URL 목록 */
      images?: string[];
    };
    appliedAutomation?: OngoingAutomation;
    /**
     * 개인정보보호 약관 동의 여부
     * @default true
     */
    hasAgreedPrivacyTerms: boolean;
    /**
     * 환자의 서비스 중단 상태 여부
     * @default false
     */
    isClosed: boolean;
    /** 서비스 종료시 사용자가 선택한 서비스 종료 이유. 혹은 병원에서 서비스를 종료한 후 사용자에게 보여주기 위한 문구. */
    closeReason?: any[];
    nationality?: {
      /** 국가/국적 ID */
      id: string;
      /**
       * 한국어 국가명
       * @example "중국, 일본, 미국, 러시아"
       */
      koreanCountryName: string;
    };
    appliedAutomations?: {
      /** 적용된 자동화 객체 ID */
      _id: string;
      algorithmType?: "CONSULTATION" | "MARKETING";
      /** 병원 ID */
      hospitalID: string;
      /** 자동화가 적용된 HService ID */
      hserviceID: string;
      /** 해당 자동화를 트리거하게 된 TreatmentCategory 객체 */
      treatmentCategoryID?: {
        /** 치료태그의 ID */
        _id?: string;
        /** 치료태그의 이름 */
        categoryName?: string;
        /** 치료태그의 색상의 hex 코드 */
        color?: string;
      };
      /** 해당 자동화를 트리거하게 된 국가 정보 */
      countryID?: {
        /** 국가코드 ID */
        _id?: string;
        /** 국가코드의 한국어 명 */
        koreanCountryName?: string;
        /** 해당 국가의 전화번호 접두 */
        internationalDialingCodes?: string;
        /** 해당 국가의 2자리 알파뱃 코드 */
        countryCodeISOAlpha2?: string;
        /** 해당 국가의 3자리 알파뱃 코드 */
        countryCodeISOAlpha3?: string;
      };
      /** 자동화 객체 정보 */
      algorithmID?: {
        /** 자동화 ID */
        _id?: string;
        /** 자동화의 이름 */
        name?: string;
        /** 자동화의 타입 구분 */
        type?: "CONSULTATION" | "MARKETING";
      };
      /** 해당 자동화의 상태 */
      status?: "PROGRESS" | "PAUSE" | "STOP" | "COMPLATE";
      /** 상태의 값이 stop인 경우 해당 사유 */
      terminateReason?: string;
      /** 생성일 */
      createdAt?: string;
      /** 마지막 수정일 */
      updatedAt?: string;
      /** 해당 자동화의 시작일시 */
      startedAt?: string;
      /** 해당 자동화의 종료일시 */
      terminatedAt?: string;
    }[];
    /** 고객 태그 그룹 객체 (태그 그룹 ID를 키로 사용) */
    customTagGroups?: Record<
      string,
      {
        /** 태그 그룹 이름 */
        name: string;
        /**
         * 태그 그룹 생성일시
         * @format date-time
         */
        createdAt: string;
        /** 해당 그룹에 속한 고객 태그 목록 */
        tags: {
          /** 고객 태그 ID */
          id: string;
          /** 고객 태그 이름 */
          name: string;
        }[];
      }
    >;
  };
};

export interface ApiPatientsElTemporaryListOrSearchParams {
  /** 병원 아이디 */
  hospitalID: string;
  /** 커서 (order). 최초 호출 이후 응답 값에 nextCursor 값이 주어집니다. */
  cursor?: string;
  /** 한 페이지당 항목 수 (기본값=20) */
  limit?: number;
  /** 환자명(또는 기획서 상 고객명) - ',' 로 구분하여 여러명 검색 불가 */
  patientName?: string;
  /** 차트번호 - ',' 로 구분하여 여러명 검색 불가 */
  chartNumber?: string;
  /** 초진 여부 (true=초진, false=재진) - ',' 로 구분하여 여러명 검색 불가 */
  isFirstVisit?: boolean;
  /** 국가번호. _id 값을 ObjectId 문자열 그대로 넣어주세요. - ',' 로 구분하여 다중 검색 가능 */
  countryCode?: string;
  /** 휴대폰번호 - ',' 로 구분하여 여러명 검색 불가 */
  phone?: string;
  /** 생년월일 - ',' 로 구분하여 여러명 검색 불가 */
  birth?: string;
  /** 성별 (MALE=남성, FEMALE=여성) - ',' 로 구분하여 여러명 검색 불가 */
  gender?: "MALE" | "FEMALE";
  /** 치료태그. _id 값을 ObjectId 문자열 그대로 넣어주세요. - ',' 로 구분하여 다중 검색 가능 */
  treatmentCategories?: string;
  /** 고객 태그. _id 값을 ObjectId 문자열 그대로 넣어주세요. - ',' 로 구분하여 다중 검색 가능 */
  customTagIDs?: string;
  /** 국적. _id 값을 ObjectId 문자열 그대로 넣어주세요. - ',' 로 구분하여 다중 검색 가능 */
  nationality?: string;
}

export type ApiPatientsElTemporaryListOrSearchData = ApiResponse & {
  data: {
    /** 전체 환자 수 */
    totalCount: number;
    /** 현재 페이지 번호 */
    page: number;
    /** 한 페이지당 항목 수 */
    limit: number;
    /** 다음 페이지 존재 여부 */
    hasNextPage: boolean;
    /** 다음 페이지에서 조회할 첫 번째 환자 아이디 */
    nextCursor: string;
    patients?: {
      /** 임시 저장된 환자 고유 ID */
      patientId: string;
      /** 환자 정보 임시 저장을 위한 ID 값. 중복되지 않아야 함. 표에서 보이는 순서대로 1부터 증가 */
      order: number;
      /** 환자 이름 */
      name: string;
      /** 스마트닥터 연동 여부 */
      hasSmartDoctorLinkage?: boolean;
      /** 카카오 연동 여부 */
      hasKakaoLinkage?: boolean;
      /** 애프터닥 가입 여부 */
      isJoinedUserToAfterDoc?: boolean;
      /** 전화번호 */
      phoneNumber: string;
      countryCode?: {
        /** 국가 ID */
        id: string;
        /** 한국어 국가명 */
        koreanCountryName: string;
        /** 국제 전화 코드 */
        internationalDialingCodes: string;
      } | null;
      /**
       * 생년월일
       * @format date
       */
      birthdate?: string;
      /** 성별 */
      gender?: "MALE" | "FEMALE";
      /** 치료 태그 목록 */
      treatmentTags?: (TreatmentTag & any)[];
      /** 고객 태그 목록 (GroupId를 키로 하는 객체) */
      customTags?: Record<
        string,
        {
          /** 고객 태그 ID */
          tagId: string;
          /** 고객 태그 이름 */
          name: string;
        }[]
      >;
      /** 초진 여부 */
      isFirstVisit?: boolean;
      /** 차트 번호 */
      chartNumber?: string;
      nationality?: {
        /** 국가/국적 ID */
        id: string;
        /** 한국어 국가명 */
        koreanCountryName: string;
      };
      /** 메시지 보내기 차단 여부 */
      hasToBlockSendingMessage?: boolean;
    }[];
  };
};

export type ApiPatientsElTemporaryData = ApiResponse & {
  data: {
    /** 성공적으로 저장된 고객 수 */
    successCount: number;
    /** 저장 실패한 고객 수 */
    failCount: number;
    failedInfos?: {
      /** 저장 실패한 고객 정보 */
      patient?: Record<string, any>;
      errors?: {
        /** 에러가 발생한 환자 이름 */
        name?: string;
        /** 에러가 발생한 전화번호 */
        phoneNumber?: string;
        /** 에러가 발생한 국가 ID */
        countryCodeId?: string;
        /** 에러가 발생한 생년월일 */
        birthdate?: string;
        /** 에러가 발생한 성별 */
        gender?: string;
        treatmentTagIds?: {
          /** 에러가 발생한 치료 태그 ID */
          tagId?: string;
          /** 에러 이유 */
          reason?: string;
        }[];
        /** 에러가 발생한 초진 여부 */
        isFirstVisit?: string;
        /** 에러가 발생한 차트 번호 */
        chartNumber?: string;
        /** 에러가 발생한 국적 ID */
        nationalityId?: string;
        customTagIDs?: {
          /** 에러가 발생한 고객 태그 ID */
          tagId?: string;
          /** 에러 이유 */
          reason?: string;
        }[];
      };
    }[];
  };
};

export interface TemporaryPatientsDeletionHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type TemporaryPatientsDeletionHandlerData = TemporaryPatientsDeletionHandlerResponse;

export type ApiPatientsRegistrationsElInvitationWithSmsData = ApiResponse & {
  data: UserHServicePhotoAuthorizationType;
};

export type ApiPatientsRegistrationsElReinvitationWithSmsData = ApiResponse & {
  data: UserHServicePhotoAuthorizationType;
};

export interface ApiPatientsMemosElFindOneParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 환자의 유저 ID */
  userID?: string;
  /** (required) 병원서비스 ID */
  hserviceID?: string;
}

export type ApiPatientsMemosElFindOneData = ApiResponse & {
  data: HServiceMemoWriterModifier;
};

export type ApiPatientsMemosElUpdateData = ApiResponse & {
  data: HServiceMemoWriterModifier;
};

export interface ApiPatientsMemosHmFindOneParams {
  /** (required) 병원 ID */
  hospitalID?: string;
  /** (required) 환자의 유저 ID */
  userID?: string;
  /** (required) 병원서비스 ID */
  hserviceID?: string;
}

export type ApiPatientsMemosHmFindOneData = ApiResponse & {
  data: HServiceMemoWriterModifier;
};

export type ApiPatientsMemosHmUpdateData = ApiResponse & {
  data: HServiceMemoWriterModifier;
};

export type PatientControllerUpdateMarketingAgreementData = PatientControllerUpdateMarketingAgreementResponse;

export type PatientControllerCreateSinglePatientData = PatientControllerCreateSinglePatientResponse;

export interface SinglePatientDeletionHandlerParams {
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
  /**
   * 환자 ID
   * @example "5f7b1b3b7b7b7b7b7b7b7b7b"
   */
  patientId: string;
}

export type SinglePatientDeletionHandlerData = SinglePatientDeletionHandlerResponse;

export type PatientControllerCreateTemporaryPatientsData = PatientControllerCreateTemporaryPatientsResponse;

export type PatientControllerGetTemporaryPatientMaxOrderData = PatientControllerGetTemporaryPatientMaxOrderResponse;

export type PatientControllerStartBulkRegistrationData = PatientControllerStartBulkRegistrationResponse;

export type PatientControllerStartBulkRegistrationLegacyData = PatientControllerStartBulkRegistrationLegacyResponse;

export type PatientControllerStartBulkImportData = PatientControllerStartBulkImportResponse;

export type PatientControllerFindPatientsByPhoneData = any;

export interface PatientControllerFindPatientDetailParams {
  patientId: string;
}

export type PatientControllerFindPatientDetailData = PatientControllerFindPatientDetailResponse;

export interface PatientControllerGetDailyInfoHistoryParams {
  /**
   * KST 기준 조회 일자 (YYYY-MM-DD)
   * @pattern ^\d{4}-\d{2}-\d{2}$
   */
  date: string;
  /**
   * 요약 탭: 고객입력 | 신규고객 | 치료태그 등록 | 상담자동화 적용
   * @default "customer_input"
   */
  tab: "customer_input" | "new_customer" | "treatment_tag" | "automation";
  /** 검색 대상 필드 */
  searchType?: "name" | "chartNumber" | "phone" | "birth";
  /** 부분일치 검색 키워드 */
  keyword?: string;
  /**
   * 페이징 오프셋
   * @min 0
   * @default 0
   */
  offset?: number | null;
  /**
   * 페이지 크기
   * @min 1
   * @max 100
   * @default 20
   */
  limit: number;
  /** 성별 필터 배열. 'M'(남)/'F'(여). 표준 방식: genders=M&genders=F. 둘 다이면 미상 제외 */
  genders?: ("M" | "F")[] | null;
  /** 치료태그 tagId 콤마구분 (OR 매칭). NO_TAG 토큰=치료태그 미입력 고객 */
  treatmentCategories?: string;
}

export type PatientControllerGetDailyInfoHistoryData = PatientControllerGetDailyInfoHistoryResponse;

export interface HServiceMemoControllerFindOneParams {
  /**
   * 병원 ID
   * @example "6732be0387ee3809f9d7632d"
   */
  hospitalID: string;
  /**
   * 병원서비스 ID
   * @example "6732be1387ee3809f9d76383"
   */
  hserviceID: string;
  /**
   * 환자의 유저 ID
   * @example "6732be2387ee3809f9d763a1"
   */
  userID: string;
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수. 0 이면 제한 없음 */
  limit?: number;
  /** 정렬하고자 하는 field. 정렬은 updatedAt 고정이라 무시된다 (레거시 호환용) */
  key?: string;
  /** 정렬하고자 하는 방향. 정렬은 내림차순 고정이라 무시된다 (레거시 호환용) */
  way?: number;
}

export type HServiceMemoControllerFindOneData = HServiceMemoControllerFindOneResponse;

export type HServiceMemoControllerUpdateData = HServiceMemoControllerUpdateResponse;

export interface TemporaryPatientsIsLockHandlerParams {
  hospitalID: string;
}

export type TemporaryPatientsIsLockHandlerData = TemporaryPatientsIsLockHandlerResponse;

export type TemporaryPatientsRequestLockHandlerData = TemporaryPatientsRequestLockHandlerResponse;

export type TemporaryPatientsLastModifierHandlerData = TemporaryPatientsLastModifierHandlerResponse;

export type TemporaryPatientsProcessingBatchHandlerData = TemporaryPatientsProcessingBatchHandlerResponse;

export type TempPatientsProcessingBatchHandlerData = TempPatientsProcessingBatchHandlerResponse;

export interface ElFindLinkedChatroomsHandlerParams {
  hserviceID: string;
}

export type ElFindLinkedChatroomsHandlerData = ElFindLinkedChatroomsHandlerResponse;

export type ServiceRegistrationBySocialChannelHandlerData = ServiceRegistrationBySocialChannelHandlerResponse;

export type InSejongPatientsHandlerData = InSejongPatientsHandlerResponse;

export interface PatientTreatmentTagHistoriesFindHandlerParams {
  /** 병원 ID */
  hospitalID: string;
  /** 병원서비스 ID */
  hserviceID: string;
  /** 시작일자 (YYYY-MM-DD) */
  startDate?: string | "";
  /** 종료일자 (YYYY-MM-DD) */
  endDate?: string | "";
  /** 스킵하고자 하는 데이터 갯수 */
  skip?: number;
  /** 조회하고자 하는 총 데이터 갯수 */
  limit?: number;
  /** 정렬하고자 하는 field */
  key?: string;
  /** 정렬하고자 하는 방향. 1 오름차순, -1 내림차순 */
  way?: string;
}

export type PatientTreatmentTagHistoriesFindHandlerData = PatientTreatmentTagHistoriesFindHandlerResponse;

export interface PatientTreatmentTagHistoriesCountHandlerParams {
  /** 병원 ID */
  hospitalID: string;
  /** 병원서비스 ID */
  hserviceID: string;
  /**
   * 시작일자 (YYYY-MM-DD)
   * @pattern ^\d{4}-\d{2}-\d{2}$
   */
  startDate: string;
  /**
   * 종료일자 (YYYY-MM-DD)
   * @pattern ^\d{4}-\d{2}-\d{2}$
   */
  endDate: string;
}

export type PatientTreatmentTagHistoriesCountHandlerData = PatientTreatmentTagHistoriesCountHandlerResponse;

export interface ExportTempPatientsByRefKeyHandlerParams {
  /**
   * 일괄 입력 시 업로드 구분을 위한 참조 키
   * @example "1704067200000"
   */
  refkey: string;
  /**
   * 병원 ID
   * @example "63d7bafc1374672f7c407efd"
   */
  hospitalID: string;
}

export type ExportTempPatientsByRefKeyHandlerData = ExportTempPatientsByRefKeyHandlerResponse;

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import { axiosInstance } from '../../../../instances/axios-instance';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axiosInstance;
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title AfterDoc API
 * @version 1.0.0
 * @baseUrl https://dev.api.afterdoc.net
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  v3 = {
    /**
     * @description 특정 환자의 상세 정보를 조회합니다.
     *
     * @tags V3-Patient
     * @name ApiPatientsElDetail
     * @summary 환자 세부 정보 조회
     * @request GET:/v3/api/patients/el/detail
     * @secure
     * @response `200` `ApiPatientsElDetailData` 환자 세부 정보 조회 성공
     */
    apiPatientsElDetail: (query: ApiPatientsElDetailParams, params: RequestParams = {}) =>
      this.request<ApiPatientsElDetailData, any>({
        path: `/v3/api/patients/el/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 병원의 환자 고객 정보 목록을 조회하거나 검색합니다.
     *
     * @tags V3-Patient
     * @name ApiPatientsElListOrSearch
     * @summary 전체 환자 정보 목록 조회 또는 검색 API
     * @request GET:/v3/api/patients/el/list-or-search
     * @secure
     * @response `200` `ApiPatientsElListOrSearchData` 고객 정보 목록 조회 성공
     */
    apiPatientsElListOrSearch: (query: ApiPatientsElListOrSearchParams, params: RequestParams = {}) =>
      this.request<ApiPatientsElListOrSearchData, any>({
        path: `/v3/api/patients/el/list-or-search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 치료 태그가 미등로된 환자 정보 목록을 조회하거나 검색합니다.
     *
     * @tags V3-Patient
     * @name ApiPatientsElListOrSearchForUntagged
     * @summary 치료 태그가 미등록된 환자 정보 목록 조회 또는 검색 API
     * @request GET:/v3/api/patients/el/list-or-search/for-untagged
     * @secure
     * @response `200` `ApiPatientsElListOrSearchForUntaggedData` 고객 정보 목록 조회 성공
     */
    apiPatientsElListOrSearchForUntagged: (
      query: ApiPatientsElListOrSearchForUntaggedParams,
      params: RequestParams = {},
    ) =>
      this.request<ApiPatientsElListOrSearchForUntaggedData, any>({
        path: `/v3/api/patients/el/list-or-search/for-untagged`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 병원의 태그가 등록되지 않은 환자 수를 조회합니다.
     *
     * @tags V3-Patient
     * @name ApiPatientsElUntaggedCount
     * @summary 태그 미등록 환자 수 조회 API
     * @request GET:/v3/api/patients/el/untagged/count
     * @secure
     * @response `200` `ApiPatientsElUntaggedCountData` 태그 미등록 환자 수 조회 성공
     */
    apiPatientsElUntaggedCount: (query: ApiPatientsElUntaggedCountParams, params: RequestParams = {}) =>
      this.request<ApiPatientsElUntaggedCountData, any>({
        path: `/v3/api/patients/el/untagged/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 병원의 전체 환자(고객) 수를 조회합니다. 병원 ID는 토큰에서 자동으로 가져옵니다.
     *
     * @tags V3-Patient
     * @name ApiPatientsElCount
     * @summary 전체 환자(고객) 수 조회 API
     * @request GET:/v3/api/patients/el/count
     * @secure
     * @response `200` `ApiPatientsElCountData` 전체 환자 수 조회 성공
     */
    apiPatientsElCount: (params: RequestParams = {}) =>
      this.request<ApiPatientsElCountData, any>({
        path: `/v3/api/patients/el/count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 태그가 미등록된 환자(고객)들에게 치료 태그를 등록합니다.
     *
     * @tags V3-Patient
     * @name ApiPatientsElUntaggedTarget
     * @summary 태그 미등록 고객 대상 치료 태그 단일/일괄 등록 요청 API
     * @request POST:/v3/api/patients/el/untagged-target
     * @secure
     * @response `200` `ApiPatientsElUntaggedTargetData` 태그 등록 성공
     */
    apiPatientsElUntaggedTarget: (
      data: {
        /** 환자 ID */
        patientId: string;
        /** 치료 태그 ID 목록 */
        treatmentTagIds: string[];
        /** 국적 ID */
        nationalityId?: string | null;
        /** 고객 태그 ID 목록 */
        customTagIDs?: string[] | null;
      }[],
      params: RequestParams = {},
    ) =>
      this.request<ApiPatientsElUntaggedTargetData, any>({
        path: `/v3/api/patients/el/untagged-target`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 단일 고객의 정보를 수정합니다.
     *
     * @tags V3-Patient
     * @name ApiPatientsElUpsertSingle
     * @summary 단일 고객 정보 수정 요청 API
     * @request POST:/v3/api/patients/el/upsert/single
     * @secure
     * @response `200` `ApiPatientsElUpsertSingleData` 고객 정보 수정 성공
     */
    apiPatientsElUpsertSingle: (
      data: {
        /** 환자 고유 ID */
        patientId: string;
        /** 환자 이름 */
        name: string;
        /** 전화번호 */
        phoneNumber: string;
        /** 국가번호 ID - 국가/국적 목록 조회 API를 통해 확인 가능 */
        countryCodeId?: string;
        /**
         * 생년월일
         * @format date
         */
        birthdate?: string | null;
        /** 성별 */
        gender?: "MALE" | "FEMALE" | null;
        /** 치료 태그 ID 목록 */
        treatmentTagIds?: string[] | null;
        /** 초진 여부 */
        isFirstVisit?: boolean | null;
        /** 차트 번호 */
        chartNumber?: string | null;
        /** 국적 ID - 국가/국적 목록 조회 API를 통해 확인 가능 */
        nationalityId?: string | null;
        /** 고객 태그 ID 목록 - null이면 모든 고객 태그 제거, 빈 배열이면 모든 고객 태그 제거 */
        customTagIDs?: string[] | null;
        /** 마케팅 수신 동의 여부 */
        isAdSMSBlocked?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPatientsElUpsertSingleData, any>({
        path: `/v3/api/patients/el/upsert/single`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 예약만 등록 및 중복된 유저를 제거한 고객 정보 로드
     *
     * @tags V3-TemporaryPatient
     * @name ApiPatientsElTemporaryV2ReservationToday
     * @summary 당일 예약 정보를 기반으로 한 임시 고객 정보 로드 API
     * @request POST:/v3/api/patients/el/temporary/v2reservation/today
     * @secure
     * @response `200` `ApiPatientsElTemporaryV2ReservationTodayData` 고객 정보 임시 저장 결과
     */
    apiPatientsElTemporaryV2ReservationToday: (
      data: {
        /** (required) 병원 ID */
        hospitalID: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPatientsElTemporaryV2ReservationTodayData, any>({
        path: `/v3/api/patients/el/temporary/v2reservation/today`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 환자의 상세 정보를 조회합니다.
     *
     * @tags V3-Patient
     * @name ApiPatientsHmDetail
     * @summary 환자 세부 정보 조회
     * @request GET:/v3/api/patients/hm/detail
     * @secure
     * @response `200` `ApiPatientsHmDetailData` 환자 세부 정보 조회 성공
     */
    apiPatientsHmDetail: (query: ApiPatientsHmDetailParams, params: RequestParams = {}) =>
      this.request<ApiPatientsHmDetailData, any>({
        path: `/v3/api/patients/hm/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 임시 저장된 고객 정보 목록을 조회하거나 검색합니다. 과거 고객 업로드 일괄 입력이 아닌 일반 임시 환자만 조회됩니다.
     *
     * @tags V3-TemporaryPatient
     * @name ApiPatientsElTemporaryListOrSearch
     * @summary (임시 저장된) 고객 정보 목록 조회 또는 검색 API
     * @request GET:/v3/api/patients/el/temporary/list-or-search
     * @secure
     * @response `200` `ApiPatientsElTemporaryListOrSearchData` 임시 저장된 고객 정보 조회 성공
     */
    apiPatientsElTemporaryListOrSearch: (query: ApiPatientsElTemporaryListOrSearchParams, params: RequestParams = {}) =>
      this.request<ApiPatientsElTemporaryListOrSearchData, any>({
        path: `/v3/api/patients/el/temporary/list-or-search`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 여러 고객의 정보를 임시로 저장합니다.
     *
     * @tags V3-TemporaryPatient
     * @name ApiPatientsElTemporary
     * @summary 고객 정보 '임시' 저장 요청 API
     * @request POST:/v3/api/patients/el/temporary
     * @deprecated
     * @secure
     * @response `200` `ApiPatientsElTemporaryData` 고객 정보 임시 저장 결과
     */
    apiPatientsElTemporary: (
      data: {
        /** 병원 ID */
        hospitalID: string;
        /**
         * 환자 정보 임시 저장을 위한 ID 값. 중복되지 않아야 함. 표에서 보이는 순서대로 1부터 증가
         * @min 1
         * @default 1
         * @example 1
         */
        order: number;
        /** 고객 이름 */
        name?: string | null;
        /** 전화번호 */
        phoneNumber?: string | null;
        /** 국가 ID */
        countryCodeId?: string | null;
        /**
         * 생년월일
         * @format date
         */
        birthdate?: string | null;
        /** 성별 */
        gender?: "MALE" | "FEMALE" | null;
        /** 치료 태그 ID 목록 */
        treatmentTagIds?: string[];
        /** 초진 여부 */
        isFirstVisit?: boolean | null;
        /** 차트 번호 */
        chartNumber?: string | null;
        /** 국적 ID */
        nationalityId?: string | null;
        /** 메시지 보내기 차단 여부 */
        hasToBlockSendingMessage?: boolean | null;
        /** 고객 태그 ID 목록 */
        customTagIDs?: string[];
        /** 과거 데이터 일괄 입력 여부. true인 경우 중복 제거 로직을 건너뛰고 무조건 저장됩니다. */
        isBulkImport?: boolean | null;
        /** 고객 등록 실패 여부 */
        isFailed?: boolean | null;
      }[],
      params: RequestParams = {},
    ) =>
      this.request<ApiPatientsElTemporaryData, any>({
        path: `/v3/api/patients/el/temporary`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 실제 병원에 등록되지 않은 오늘 날짜의 임시 환자 정보를 물리적 삭제 처리합니다.
     *
     * @tags V3-TemporaryPatient
     * @name TemporaryPatientsDeletionHandler
     * @summary 오늘 날짜 임시 환자 정보 물리적 삭제 처리 - 태웅님 테스트용
     * @request DELETE:/v3/api/patients/el/temporary
     * @secure
     * @response `200` `TemporaryPatientsDeletionHandlerData` success
     */
    temporaryPatientsDeletionHandler: (query: TemporaryPatientsDeletionHandlerParams, params: RequestParams = {}) =>
      this.request<TemporaryPatientsDeletionHandlerData, any>({
        path: `/v3/api/patients/el/temporary`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-PatientRegistration
     * @name ApiPatientsRegistrationsElInvitationWithSms
     * @summary 병원 앱에서의 환자 가입문자 발송
     * @request POST:/v3/api/patients/registrations/el/invitation/with-sms
     * @secure
     * @response `200` `ApiPatientsRegistrationsElInvitationWithSmsData` \{User\} 객체 조회
     */
    apiPatientsRegistrationsElInvitationWithSms: (
      data: {
        /** 생성하고자 하는 환자의 이름 */
        name?: string;
        /** 생성하고자 하는 환자의 전화번호 */
        phone: string;
        /** 가입하고자 하는 병원 ID */
        hospitalID: string;
        /**
         * 유저의 Type. 1000고정
         * @default "1000"
         */
        type: string;
        /**
         * SMS에 포함될 메시지
         * @default "Some Message {{Link}}"
         */
        message: string;
        /** 국가 코드 ObjectID */
        countryCode: string;
        /**
         * 전능 연동 API 서버를 통해 온 경우 분기 flag
         * @default false
         */
        isSendFromSIAPI?: boolean;
        /**
         * 가입문자 메시지 다시 불러오기 여부
         * @default false
         */
        shouldReloadRegistSMS?: boolean;
        /**
         * SMS 발송 여부. /v3/api/patients/el/link/social-channel 에서 참조하여 쓸때 사용
         * @default false
         */
        shouldSkipSendSMS?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPatientsRegistrationsElInvitationWithSmsData, any>({
        path: `/v3/api/patients/registrations/el/invitation/with-sms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-PatientRegistration
     * @name ApiPatientsRegistrationsElReinvitationWithSms
     * @summary 병원 앱에서의 환자 가입문자 재발송
     * @request POST:/v3/api/patients/registrations/el/reinvitation/with-sms
     * @secure
     * @response `200` `ApiPatientsRegistrationsElReinvitationWithSmsData` \{User\} 객체 조회
     */
    apiPatientsRegistrationsElReinvitationWithSms: (
      data: {
        /** 병원 아이디 */
        hospitalID: string;
        /** 병원 서비스 아이디 */
        hserviceID: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPatientsRegistrationsElReinvitationWithSmsData, any>({
        path: `/v3/api/patients/registrations/el/reinvitation/with-sms`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-PatientMemo
     * @name ApiPatientsMemosElFindOne
     * @summary 병원 서비스별 단일 고객 메모 조회 (GET /v3/api/patients/memos/find/one 로 대체됨)
     * @request GET:/v3/api/patients/memos/el/find/one
     * @deprecated
     * @secure
     * @response `200` `ApiPatientsMemosElFindOneData` \{HServiceMemo\} HServiceMemo 컬렉션 객체
     */
    apiPatientsMemosElFindOne: (query: ApiPatientsMemosElFindOneParams, params: RequestParams = {}) =>
      this.request<ApiPatientsMemosElFindOneData, any>({
        path: `/v3/api/patients/memos/el/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description userID, hospiatlID, hserviceID 세가지를 기준으로 upsert 동작
     *
     * @tags V3-PatientMemo
     * @name ApiPatientsMemosElUpdate
     * @summary 병원 서비스별 단일 고객 메모 수정 (POST /v3/api/patients/memos/update 로 대체됨)
     * @request POST:/v3/api/patients/memos/el/update
     * @deprecated
     * @secure
     * @response `200` `ApiPatientsMemosElUpdateData` \{HServiceMemo\} HServiceMemo 컬렉션 객체
     */
    apiPatientsMemosElUpdate: (
      data: {
        /** (required) 병원 ID */
        hospitalID?: string;
        /** (required) 환자의 유저 ID */
        userID?: string;
        /** (required) 병원서비스 ID */
        hserviceID?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPatientsMemosElUpdateData, any>({
        path: `/v3/api/patients/memos/el/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags V3-PatientMemo
     * @name ApiPatientsMemosHmFindOne
     * @summary 병원 상담 모바일 앱 - 병원 서비스별 단일 고객 메모 조회 (GET /v3/api/patients/memos/find/one 로 대체됨)
     * @request GET:/v3/api/patients/memos/hm/find/one
     * @deprecated
     * @secure
     * @response `200` `ApiPatientsMemosHmFindOneData` \{HServiceMemo\} HServiceMemo 컬렉션 객체
     */
    apiPatientsMemosHmFindOne: (query: ApiPatientsMemosHmFindOneParams, params: RequestParams = {}) =>
      this.request<ApiPatientsMemosHmFindOneData, any>({
        path: `/v3/api/patients/memos/hm/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description userID, hospiatlID, hserviceID 세가지를 기준으로 upsert 동작
     *
     * @tags V3-PatientMemo
     * @name ApiPatientsMemosHmUpdate
     * @summary 병원 상담 모바일 앱 - 병원 서비스별 단일 고객 메모 수정 (POST /v3/api/patients/memos/update 로 대체됨)
     * @request POST:/v3/api/patients/memos/hm/update
     * @deprecated
     * @secure
     * @response `200` `ApiPatientsMemosHmUpdateData` \{HServiceMemo\} HServiceMemo 컬렉션 객체
     */
    apiPatientsMemosHmUpdate: (
      data: {
        /** (required) 병원 ID */
        hospitalID?: string;
        /** (required) 환자의 유저 ID */
        userID?: string;
        /** (required) 병원 서비스 ID */
        hserviceID?: string;
        content?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiPatientsMemosHmUpdateData, any>({
        path: `/v3/api/patients/memos/hm/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 마케팅 수신 동의 여부를 업데이트합니다
     *
     * @tags V3-Patient
     * @name PatientControllerUpdateMarketingAgreement
     * @summary 마케팅 수신 동의 여부 업데이트
     * @request PATCH:/v3/api/patients/el/update/marketing-agreement
     * @secure
     * @response `200` `PatientControllerUpdateMarketingAgreementData` success
     */
    patientControllerUpdateMarketingAgreement: (
      data: PatientControllerUpdateMarketingAgreementBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<PatientControllerUpdateMarketingAgreementData, any>({
        path: `/v3/api/patients/el/update/marketing-agreement`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 곧바로 환자를 생성합니다
     *
     * @tags V3-Patient
     * @name PatientControllerCreateSinglePatient
     * @summary 단일 환자 생성 처리
     * @request POST:/v3/api/patients/el/single
     * @secure
     * @response `200` `PatientControllerCreateSinglePatientData` success
     */
    patientControllerCreateSinglePatient: (
      data: PatientControllerCreateSinglePatientBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<PatientControllerCreateSinglePatientData, any>({
        path: `/v3/api/patients/el/single`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 단일 환자를 삭제 처리합니다.
     *
     * @tags V3-Patient
     * @name SinglePatientDeletionHandler
     * @summary 특정 단일 환자 삭제 처리
     * @request DELETE:/v3/api/patients/el/single
     * @secure
     * @response `200` `SinglePatientDeletionHandlerData` success
     */
    singlePatientDeletionHandler: (query: SinglePatientDeletionHandlerParams, params: RequestParams = {}) =>
      this.request<SinglePatientDeletionHandlerData, any>({
        path: `/v3/api/patients/el/single`,
        method: "DELETE",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 여러 고객의 정보를 임시로 저장합니다.
     *
     * @tags V3-Patient
     * @name PatientControllerCreateTemporaryPatients
     * @summary 고객 정보 임시 저장
     * @request POST:/v3/api/patients/temporary
     * @secure
     * @response `200` `PatientControllerCreateTemporaryPatientsData` success
     */
    patientControllerCreateTemporaryPatients: (
      data: PatientControllerCreateTemporaryPatientsBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<PatientControllerCreateTemporaryPatientsData, any>({
        path: `/v3/api/patients/temporary`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 병원의 오늘 생성된 임시 환자 중 최대 order 값을 조회합니다.
     *
     * @tags V3-Patient
     * @name PatientControllerGetTemporaryPatientMaxOrder
     * @summary 임시 환자 최대 order 조회
     * @request GET:/v3/api/patients/temporary/max-order
     * @secure
     * @response `200` `PatientControllerGetTemporaryPatientMaxOrderData` success
     */
    patientControllerGetTemporaryPatientMaxOrder: (params: RequestParams = {}) =>
      this.request<PatientControllerGetTemporaryPatientMaxOrderData, any>({
        path: `/v3/api/patients/temporary/max-order`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 하나 이상의 환자(고객) 정보를 일괄 저장합니다.
     *
     * @tags V3-Patient
     * @name PatientControllerStartBulkRegistration
     * @summary 환자(고객) 정보 일괄 저장 요청 API
     * @request POST:/v3/api/patients/bulk-registration
     * @secure
     * @response `200` `PatientControllerStartBulkRegistrationData` success
     */
    patientControllerStartBulkRegistration: (
      data: PatientControllerStartBulkRegistrationBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<PatientControllerStartBulkRegistrationData, any>({
        path: `/v3/api/patients/bulk-registration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 하나 이상의 환자(고객) 정보를 일괄 저장합니다. (구 URL)
     *
     * @tags V3-Patient
     * @name PatientControllerStartBulkRegistrationLegacy
     * @summary 환자(고객) 정보 일괄 저장 요청 API (deprecated)
     * @request POST:/v3/api/patients/el
     * @secure
     * @response `200` `PatientControllerStartBulkRegistrationLegacyData` success
     */
    patientControllerStartBulkRegistrationLegacy: (
      data: PatientControllerStartBulkRegistrationLegacyBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<PatientControllerStartBulkRegistrationLegacyData, any>({
        path: `/v3/api/patients/el`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description S3 에 업로드된 엑셀을 검증하고, 통과 시 비동기 임포트 job 을 생성합니다.
     *
     * @tags V3-Patient
     * @name PatientControllerStartBulkImport
     * @summary 엑셀 일괄 임포트
     * @request POST:/v3/api/patients/bulk-import
     * @secure
     * @response `200` `PatientControllerStartBulkImportData` success
     */
    patientControllerStartBulkImport: (data: PatientControllerStartBulkImportBodyRequest, params: RequestParams = {}) =>
      this.request<PatientControllerStartBulkImportData, any>({
        path: `/v3/api/patients/bulk-import`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 전화번호로 환자 조회
     *
     * @tags V3-Patient
     * @name PatientControllerFindPatientsByPhone
     * @summary 전화번호로 환자 조회
     * @request GET:/v3/api/patients/by-phone
     * @secure
     * @response `200` `PatientControllerFindPatientsByPhoneData` 成功响应
     */
    patientControllerFindPatientsByPhone: (params: RequestParams = {}) =>
      this.request<PatientControllerFindPatientsByPhoneData, any>({
        path: `/v3/api/patients/by-phone`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * @description 특정 고객의 상세 정보를 조회합니다.
     *
     * @tags V3-Patient
     * @name PatientControllerFindPatientDetail
     * @summary 고객 세부 정보 조회
     * @request GET:/v3/api/patients/detail
     * @secure
     * @response `200` `PatientControllerFindPatientDetailData` success
     */
    patientControllerFindPatientDetail: (query: PatientControllerFindPatientDetailParams, params: RequestParams = {}) =>
      this.request<PatientControllerFindPatientDetailData, any>({
        path: `/v3/api/patients/detail`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 특정 일자(KST)에 등록/수정된 고객의 최신 스냅샷을 환자별 1건으로 조회합니다.
     *
     * @tags V3-Patient
     * @name PatientControllerGetDailyInfoHistory
     * @summary 일자별 고객정보 입력 내역 조회
     * @request GET:/v3/api/patients/daily-info-history
     * @secure
     * @response `200` `PatientControllerGetDailyInfoHistoryData` success
     */
    patientControllerGetDailyInfoHistory: (
      query: PatientControllerGetDailyInfoHistoryParams,
      params: RequestParams = {},
    ) =>
      this.request<PatientControllerGetDailyInfoHistoryData, any>({
        path: `/v3/api/patients/daily-info-history`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description hospitalID·hserviceID·userID 로 고객 메모 1건을 조회한다. 메모가 없으면 빈 메모를 새로 만들어 돌려준다(조회가 쓰기다). 같은 세 값의 문서가 여럿이면 updatedAt 이 최신인 것을 돌려준다.
     *
     * @tags V3-PatientMemo
     * @name HServiceMemoControllerFindOne
     * @summary 병원 서비스별 단일 고객 메모 조회
     * @request GET:/v3/api/patients/memos/find/one
     * @secure
     * @response `200` `HServiceMemoControllerFindOneData` success
     */
    hServiceMemoControllerFindOne: (query: HServiceMemoControllerFindOneParams, params: RequestParams = {}) =>
      this.request<HServiceMemoControllerFindOneData, any>({
        path: `/v3/api/patients/memos/find/one`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description hospitalID·hserviceID·userID 세 값을 기준으로 upsert 한다. content 를 주지 않거나 null 이면 빈 문자열로 저장된다. 작성자와 생성일시는 처음 만들 때만 정해지고, 이후에는 수정자와 수정일시만 갱신된다.
     *
     * @tags V3-PatientMemo
     * @name HServiceMemoControllerUpdate
     * @summary 병원 서비스별 단일 고객 메모 저장
     * @request POST:/v3/api/patients/memos/update
     * @secure
     * @response `200` `HServiceMemoControllerUpdateData` success
     */
    hServiceMemoControllerUpdate: (data: HServiceMemoControllerUpdateBodyRequest, params: RequestParams = {}) =>
      this.request<HServiceMemoControllerUpdateData, any>({
        path: `/v3/api/patients/memos/update`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 환자 수정화면의 잠금 확인
     *
     * @tags V3-TemporaryPatient
     * @name TemporaryPatientsIsLockHandler
     * @summary 환자 수정화면의 잠금 확인 ts
     * @request GET:/v3/api/patients/el/islock
     * @secure
     * @response `200` `TemporaryPatientsIsLockHandlerData` success
     */
    temporaryPatientsIsLockHandler: (query: TemporaryPatientsIsLockHandlerParams, params: RequestParams = {}) =>
      this.request<TemporaryPatientsIsLockHandlerData, any>({
        path: `/v3/api/patients/el/islock`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 환자 수정화면의 잠금/해제 요청
     *
     * @tags V3-TemporaryPatient
     * @name TemporaryPatientsRequestLockHandler
     * @summary 환자 수정화면의 잠금/해제 요청 ts
     * @request PATCH:/v3/api/patients/el/requestlock
     * @secure
     * @response `200` `TemporaryPatientsRequestLockHandlerData` success
     */
    temporaryPatientsRequestLockHandler: (
      data: TemporaryPatientsRequestLockHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<TemporaryPatientsRequestLockHandlerData, any>({
        path: `/v3/api/patients/el/requestlock`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 마지막 임시저장자 요청
     *
     * @tags V3-TemporaryPatient
     * @name TemporaryPatientsLastModifierHandler
     * @summary 마지막 임시저장자 요청 ts
     * @request PATCH:/v3/api/patients/el/temporary/lastmodifier
     * @secure
     * @response `200` `TemporaryPatientsLastModifierHandlerData` success
     */
    temporaryPatientsLastModifierHandler: (
      data: TemporaryPatientsLastModifierHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<TemporaryPatientsLastModifierHandlerData, any>({
        path: `/v3/api/patients/el/temporary/lastmodifier`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 임시 저장된 환자 정보 데이터가 있는 경우 임시 저장된 정보를 매일 오후 6시, 오후 8시에 병원 별로 등록하고 알림 보내는 배치입니다.
     *
     * @tags V3-Patients-Processing-Batch
     * @name TemporaryPatientsProcessingBatchHandler
     * @summary 임시 저장된 환자 정보 병원 별 일괄 등록 및 알림 발송 배치
     * @request POST:/v3/api/patients/el/temporary-data-processing/by-hospitals/batch
     * @secure
     * @response `200` `TemporaryPatientsProcessingBatchHandlerData` success
     */
    temporaryPatientsProcessingBatchHandler: (
      data: TemporaryPatientsProcessingBatchHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<TemporaryPatientsProcessingBatchHandlerData, any>({
        path: `/v3/api/patients/el/temporary-data-processing/by-hospitals/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 하루 전 내원한 환자 데이터(임시 환자 데이터)가 가입으로 이어지지 않은 경우 처리하는 배치입니다.
     *
     * @tags V3-Patients-Processing-Batch
     * @name TempPatientsProcessingBatchHandler
     * @summary 하루 전 내원한 환자 데이터(임시 환자 데이터)가 가입으로 이어지지 않은 경우 처리하는 배치
     * @request POST:/v3/api/patients/el/processing/yesterday-not-saved-temp-patients/batch
     * @secure
     * @response `200` `TempPatientsProcessingBatchHandlerData` success
     */
    tempPatientsProcessingBatchHandler: (
      data: TempPatientsProcessingBatchHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<TempPatientsProcessingBatchHandlerData, any>({
        path: `/v3/api/patients/el/processing/yesterday-not-saved-temp-patients/batch`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 환자 기준 연동된 채팅방 목록 조회
     *
     * @tags V3-Patient
     * @name ElFindLinkedChatroomsHandler
     * @summary 환자 기준 연동된 채팅방 목록 조회 ts
     * @request GET:/v3/api/patients/el/linked-chatrooms
     * @secure
     * @response `200` `ElFindLinkedChatroomsHandlerData` success
     */
    elFindLinkedChatroomsHandler: (query: ElFindLinkedChatroomsHandlerParams, params: RequestParams = {}) =>
      this.request<ElFindLinkedChatroomsHandlerData, any>({
        path: `/v3/api/patients/el/linked-chatrooms`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 소셜 미디어 채널(카카오톡, 인스타그램, 톡톡)을 통해 문의한 정보를 고객으로 등록합니다.
     *
     * @tags V3-Patient
     * @name ServiceRegistrationBySocialChannelHandler
     * @summary 소셜 미디어 채널을 통해 문의한 정보를 고객으로 등록
     * @request POST:/v3/api/patients/el/link/social-channel
     * @secure
     * @response `200` `ServiceRegistrationBySocialChannelHandlerData` success
     */
    serviceRegistrationBySocialChannelHandler: (
      data: ServiceRegistrationBySocialChannelHandlerBodyRequest,
      params: RequestParams = {},
    ) =>
      this.request<ServiceRegistrationBySocialChannelHandlerData, any>({
        path: `/v3/api/patients/el/link/social-channel`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 인천 세종병원 환자 목록을 조회하여 새롭게 갱신합니다.
     *
     * @tags V3-TemporaryPatient
     * @name InSejongPatientsHandler
     * @summary 인천 세종병원 환자 목록 조회 및 갱신 배치
     * @request GET:/v3/api/patients/el/insejong/patients/batch
     * @secure
     * @response `200` `InSejongPatientsHandlerData` success
     */
    inSejongPatientsHandler: (params: RequestParams = {}) =>
      this.request<InSejongPatientsHandlerData, any>({
        path: `/v3/api/patients/el/insejong/patients/batch`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 환자의 치료태그 변경 이력 조회
     *
     * @tags V3-Patient
     * @name PatientTreatmentTagHistoriesFindHandler
     * @summary 환자의 치료태그 변경 이력 조회
     * @request GET:/v3/api/patients/el/histories/treatment-tags
     * @secure
     * @response `200` `PatientTreatmentTagHistoriesFindHandlerData` success
     */
    patientTreatmentTagHistoriesFindHandler: (
      query: PatientTreatmentTagHistoriesFindHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<PatientTreatmentTagHistoriesFindHandlerData, any>({
        path: `/v3/api/patients/el/histories/treatment-tags`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 환자의 치료태그 변경 이력 개수 조회
     *
     * @tags V3-Patient
     * @name PatientTreatmentTagHistoriesCountHandler
     * @summary 환자의 치료태그 변경 이력 개수 조회
     * @request GET:/v3/api/patients/el/histories/treatment-tags/count
     * @secure
     * @response `200` `PatientTreatmentTagHistoriesCountHandlerData` success
     */
    patientTreatmentTagHistoriesCountHandler: (
      query: PatientTreatmentTagHistoriesCountHandlerParams,
      params: RequestParams = {},
    ) =>
      this.request<PatientTreatmentTagHistoriesCountHandlerData, any>({
        path: `/v3/api/patients/el/histories/treatment-tags/count`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description refkey와 hospitalID로 특정 시점의 임시 환자 데이터를 조회하여 엑셀 다운로드용 데이터로 정제합니다.
     *
     * @tags V3-TemporaryPatient
     * @name ExportTempPatientsByRefKeyHandler
     * @summary refkey로 임시 환자 데이터 조회 및 정제 (엑셀 다운로드용)
     * @request GET:/v3/api/patients/el/temporary/export-by-refkey
     * @secure
     * @response `200` `ExportTempPatientsByRefKeyHandlerData` success
     */
    exportTempPatientsByRefKeyHandler: (query: ExportTempPatientsByRefKeyHandlerParams, params: RequestParams = {}) =>
      this.request<ExportTempPatientsByRefKeyHandlerData, any>({
        path: `/v3/api/patients/el/temporary/export-by-refkey`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
